import React, { useState, useEffect, useRef } from 'react';
import { 
  LayoutDashboard, Megaphone, FileBarChart2, Users, CreditCard, History, LogOut,
  Plus, Minus, Download, CheckCircle, AlertTriangle, Menu, X, Smartphone,
  Image as ImageIcon, MessageSquare, Save, BookTemplate, Phone,
  Link as LinkIcon, MousePointerClick, Video, FileText, ArrowRightLeft,
  Settings, Lock, User, LogIn, Edit, Trash2, UserPlus, ToggleRight, ToggleLeft, 
  Clock, Loader2, SmartphoneNfc, Pause, Play
} from 'lucide-react';

const API_BASE = "https://api.digitalsmarttechnology.com";

const isWhatsAppNumber = (num) => {
  if (!num) return false;
  const cleanNum = String(num).trim().replace(/\D/g, ''); 
  if (cleanNum.length !== 10) return false;
  if (!/^[6-9]/.test(cleanNum)) return false;
  if (cleanNum === '6376867242') return false;
  return true; 
};

const maskNumber = (num) => {
  if (!num) return '';
  const strNum = String(num).trim();
  if (strNum.length >= 10) {
     return strNum.substring(0, 2) + '******' + strNum.substring(strNum.length - 2);
  }
  return strNum;
};

const loadData = (key, defaultData) => {
  try {
    const localData = localStorage.getItem(key);
    if (localData) {
      const parsed = JSON.parse(localData);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
    return defaultData;
  } catch (e) { return defaultData; }
};

const fastCount = (data) => {
    if (!data || data === 'null' || data === '[]') return 0;
    if (Array.isArray(data)) return data.length;
    if (typeof data === 'string') return data.split(',').length;
    return 0;
};

const LocalDB = {
    init: function() {
        return new Promise((resolve, reject) => {
            const req = indexedDB.open("WhatsAppProDB", 1);
            req.onupgradeneeded = (e) => { e.target.result.createObjectStore("uploads", { keyPath: "tempId" }); };
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error);
        });
    },
    save: async function(data) {
        const db = await this.init();
        return new Promise((resolve) => {
            const tx = db.transaction("uploads", "readwrite");
            tx.objectStore("uploads").put(data);
            tx.oncomplete = () => resolve();
        });
    },
    getAll: async function() {
        const db = await this.init();
        return new Promise((resolve) => {
            const tx = db.transaction("uploads", "readonly");
            const req = tx.objectStore("uploads").getAll();
            req.onsuccess = () => resolve(req.result || []);
        });
    },
    delete: async function(id) {
        const db = await this.init();
        return new Promise((resolve) => {
            const tx = db.transaction("uploads", "readwrite");
            tx.objectStore("uploads").delete(id);
            tx.oncomplete = () => resolve();
        });
    }
};

const ScrollingAlert = () => (
  <div className="bg-[#00ced1] py-2 shadow-sm border-b border-teal-500 z-10 relative">
    <marquee className="text-red-600 font-bold text-sm sm:text-base tracking-wide flex items-center">
      ALERT - Dear Customers Campaigning time are From Monday to Saturday 10:00 AM to 6:00 PM. || If the number quantity is below 1000, the campaign will fail.
    </marquee>
  </div>
);

const ImportantPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[999] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full overflow-hidden border border-slate-200 transform transition-all relative">
        <div className="bg-[#fdf6ed] p-6 relative border-b border-orange-100">
          <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 text-red-600 hover:bg-red-50 p-1.5 rounded-full transition-colors">
            <X size={24} strokeWidth={3}/>
          </button>
          <h2 className="text-2xl font-black text-[#d32f2f] flex items-center gap-2">
            <span className="text-3xl">🙏</span> Important Alert
          </h2>
          <p className="text-slate-500 font-bold text-sm mt-1">To Our Valued Customers</p>
        </div>
        
        <div className="p-6 sm:p-8 space-y-4">
          <div className="bg-[#f0fdf4] border-l-4 border-[#16a34a] p-4 rounded-r-lg text-slate-800 font-medium">
            Dear Customers, Campaigning time are From Monday to Saturday 10:00 AM to 6:00 PM
          </div>
          
          <div className="bg-[#fef2f2] border-l-4 border-[#dc2626] p-4 rounded-r-lg text-slate-800 font-medium">
            Campaigns with fewer than <span className="font-black">1000 numbers</span> will be marked as <span className="text-[#dc2626] font-black uppercase">FAILED</span>.
          </div>
          
          <div className="pt-4 flex justify-end">
            <button onClick={() => setIsOpen(false)} className="bg-[#005f73] hover:bg-cyan-900 text-white px-8 py-2.5 rounded-full font-bold shadow-md transition-colors">
              Got It
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); 
  const [impersonatedUser, setImpersonatedUser] = useState(null);
  const [activeTab, setActiveTab] = useState('Dashboard'); 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [users, setUsers] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  
  const [virtualCampaigns, setVirtualCampaigns] = useState([]); 
  const [offlineQueue, setOfflineQueue] = useState([]); 
  const [isSyncing, setIsSyncing] = useState(false);

  const [creditLogs, setCreditLogs] = useState(() => loadData('wp_creditLogs', []));
  const [savedTemplates, setSavedTemplates] = useState(() => loadData('wp_templates', []));
  const [savedContacts, setSavedContacts] = useState(() => loadData('wp_contacts', []));

  useEffect(() => { localStorage.setItem('wp_creditLogs', JSON.stringify(creditLogs)); }, [creditLogs]);
  useEffect(() => { localStorage.setItem('wp_templates', JSON.stringify(savedTemplates)); }, [savedTemplates]);
  useEffect(() => { localStorage.setItem('wp_contacts', JSON.stringify(savedContacts)); }, [savedContacts]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
        if (offlineQueue.some(c => c.status === 'Uploading...')) {
            e.preventDefault(); e.returnValue = '';
        }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [offlineQueue]);

  useEffect(() => {
     const loadOffline = async () => {
         try { const pending = await LocalDB.getAll(); setOfflineQueue(pending); } catch(e){}
     };
     loadOffline();
  }, []);

  useEffect(() => {
      if(offlineQueue.length > 0 && !isSyncing && isAuthenticated) {
          processOfflineQueue();
      }
  }, [offlineQueue, isAuthenticated]);

  const processOfflineQueue = async () => {
      setIsSyncing(true);
      for (let camp of offlineQueue) {
          try {
              const campRes = await fetch(`${API_BASE}/api/campaigns`, {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(camp.payload)
              });
              if(campRes.ok) {
                  await LocalDB.delete(camp.tempId);
                  setOfflineQueue(prev => prev.filter(c => c.tempId !== camp.tempId));
                  fetchLiveData();
              }
          } catch(e) { }
      }
      setIsSyncing(false);
  };

  const fetchLiveData = async () => {
    try {
      const timestamp = new Date().getTime(); 
      const activeId = impersonatedUser?.id || currentUser?.id || '';
      const activeRole = impersonatedUser?.role || currentUser?.role || '';

      const uRes = await fetch(`${API_BASE}/api/users?t=${timestamp}&role=${activeRole}&username=${impersonatedUser?.username || currentUser?.username || ''}`);
      if (uRes.ok) {
         const fetchedUsers = await uRes.json();
         if(fetchedUsers && Array.isArray(fetchedUsers)) setUsers(fetchedUsers); 
      }
      
      const cRes = await fetch(`${API_BASE}/api/campaigns?t=${timestamp}&role=${activeRole}&userId=${activeId}`);
      if (cRes.ok) {
         let fetchedCampaigns = await cRes.json();
         if(fetchedCampaigns && Array.isArray(fetchedCampaigns)) setCampaigns(fetchedCampaigns);
      }
      
      const logRes = await fetch(`${API_BASE}/api/credit-logs?t=${timestamp}`);
      if (logRes.ok) {
          const fetchedLogs = await logRes.json();
          if(fetchedLogs && Array.isArray(fetchedLogs)) setCreditLogs(fetchedLogs);
      }
    } catch (error) { console.error("Fetch Error:", error); }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchLiveData();
      const interval = setInterval(fetchLiveData, 5000); 
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, currentUser, impersonatedUser]);

  const handleLoginSuccess = (user) => {
    setCurrentUser(user);
    setIsAuthenticated(true);
  };

  if (!isAuthenticated) return <LoginView onLogin={handleLoginSuccess} />;

  const activeUser = impersonatedUser || currentUser;
  const isAdmin = currentUser.role === 'Admin' && !impersonatedUser;
  const isReseller = activeUser.role === 'Reseller';

  const activeUserFullData = users.find(u => u.id === activeUser.id) || activeUser;
  if (activeUserFullData.role === 'Admin') {
    activeUserFullData.wBalance = 100000000;
    activeUserFullData.btnBalance = 100000000;
  }

  const processCampaignUpload = async (newCampObj, cost, campaignType) => {
      const tempId = 'temp-' + Date.now();
      const optimisticCamp = { ...newCampObj, id: tempId, status: 'Uploading...', isVirtual: true };
      
      setVirtualCampaigns(prev => [optimisticCamp, ...prev]);

      if (activeUser.role !== 'Admin') {
          try {
              await fetch(`${API_BASE}/api/users/update-credit`, {
                 method: 'POST', headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify({ userId: activeUser.id, wBalance: campaignType==='w-campaign' ? -cost : 0, btnBalance: campaignType==='button-campaign' ? -cost : 0 })
              });
              await fetch(`${API_BASE}/api/credit-logs`, {
                 method: 'POST', headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify({ userId: activeUser.id, username: activeUser.username, walletType: campaignType === 'w-campaign' ? 'W Credit' : 'Button Credit', type: 'Deduction', amount: cost, date: new Date().toLocaleString(), note: `Campaign Sent`, campaignName: newCampObj.name })
              });
              fetchLiveData(); 
          } catch(err) { console.error(err); }
      }

      try {
          const campRes = await fetch(`${API_BASE}/api/campaigns`, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(newCampObj)
          });

          if(campRes.ok) {
              setVirtualCampaigns(prev => prev.filter(c => c.id !== tempId));
              fetchLiveData(); 
          } else {
              setVirtualCampaigns(prev => prev.map(c => c.id === tempId ? { ...c, status: 'Failed' } : c));
          }
      } catch (err) {
          setVirtualCampaigns(prev => prev.map(c => c.id === tempId ? { ...c, status: 'Failed' } : c));
      }
  };

  const totalWCredits = activeUserFullData.wBalance || 0;
  const totalBtnCredits = activeUserFullData.btnBalance || 0;
  const totalCreditsCombined = totalWCredits + totalBtnCredits;
  
  const relevantCampaigns = isAdmin ? campaigns : campaigns.filter(c => c.userId === activeUser.id);
  const combinedCampaigns = [...virtualCampaigns.filter(c => isAdmin || c.userId === activeUser.id), ...relevantCampaigns];

  const totalCampaigns = combinedCampaigns.filter(c => c.status === 'Complete').length;
  const totalPending = combinedCampaigns.filter(c => c.status === 'Pending' || c.status === 'Uploading...').length;
  const totalProcess = combinedCampaigns.filter(c => c.status === 'Process' || c.status === 'Report Processing' || c.status === 'Sending Live...' || c.status === 'Paused Manually').length;

  const navigate = (tab) => { setActiveTab(tab); setIsMobileMenuOpen(false); };
  const handleLogout = () => { setIsAuthenticated(false); setCurrentUser(null); setImpersonatedUser(null); };

  return (
    <div className="flex flex-col h-screen bg-slate-50 font-sans text-slate-800">
      <ImportantPopup />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar activeTab={activeTab} navigate={navigate} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} isAdmin={isAdmin} isReseller={isReseller} onLogout={handleLogout} />
        
        <div className="flex-1 flex flex-col h-full overflow-hidden">
          <header className="bg-white border-b border-slate-200 h-16 sm:h-20 flex items-center justify-between px-4 sm:px-6 lg:px-10 z-10 shrink-0 shadow-sm">
            <div className="flex items-center">
              <button className="lg:hidden p-2 mr-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(true)}>
                <Menu size={24} />
              </button>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-slate-800 hidden sm:block">WhatsApp Pro Dashboard</h1>
                <h1 className="text-lg font-bold text-slate-800 sm:hidden">WhatsApp Pro</h1>
              </div>
            </div>
            <div className="flex items-center space-x-3 sm:space-x-5">
              <div className="text-right hidden sm:block">
                <p className="text-sm font-bold text-slate-800">{activeUser?.name || "User"}</p>
                <p className="text-xs text-blue-600 font-bold bg-blue-50 px-2 py-0.5 rounded-full inline-block mt-1">{activeUser.role} • Bal: {totalCreditsCombined.toLocaleString()}</p>
              </div>
              <div className="h-10 w-10 sm:h-12 sm:w-12 bg-blue-600 text-white rounded-xl flex items-center justify-center font-bold shadow-md border border-blue-500 text-base sm:text-lg">
                {activeUser?.name?.charAt(0) || "U"}
              </div>
            </div>
          </header>
          
          <ScrollingAlert />

          {impersonatedUser && (
            <div className="bg-amber-100 border-l-4 border-amber-500 p-3 flex justify-between items-center text-amber-900 shadow-inner shrink-0 flex-wrap gap-2">
              <div className="flex items-center text-sm sm:text-base"><AlertTriangle className="mr-2" size={18} /><span><strong>Warning:</strong> Logged in as <b>{impersonatedUser.username}</b>.</span></div>
              <button onClick={() => setImpersonatedUser(null)} className="bg-amber-500 text-white px-3 sm:px-4 py-1.5 rounded text-xs sm:text-sm font-bold shadow hover:bg-amber-600 whitespace-nowrap">Back to Admin</button>
            </div>
          )}

          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-slate-100 p-4 sm:p-6 lg:p-8 relative">
            {activeTab === 'Dashboard' && <DashboardView stats={{totalCreditsCombined, totalWCredits, totalBtnCredits, totalCampaigns, totalPending, totalProcess}} />}
            {activeTab === 'W-Campaign' && <CreateCampaignView activeUser={activeUserFullData} onProcessUpload={processCampaignUpload} onSuccess={() => navigate('Report')} savedTemplates={savedTemplates} savedContacts={savedContacts} campaignType="w-campaign" />}
            {activeTab === 'Btn-Campaign' && <CreateCampaignView activeUser={activeUserFullData} onProcessUpload={processCampaignUpload} onSuccess={() => navigate('Report')} savedTemplates={savedTemplates} savedContacts={savedContacts} campaignType="button-campaign" />}
            {activeTab === 'CreateTemplate' && <TemplatesView templates={savedTemplates} setTemplates={setSavedTemplates} />}
            {activeTab === 'CreateContact' && <ContactsView activeUser={activeUserFullData} contacts={savedContacts} setContacts={setSavedContacts} />}
            {activeTab === 'Report' && <ReportView campaigns={combinedCampaigns} isAdmin={isAdmin} users={users} fetchLiveData={fetchLiveData} navigate={navigate}/>}
            {activeTab === 'Users' && (isAdmin || isReseller) && <ManageUserView users={users} fetchLiveData={fetchLiveData} setImpersonatedUser={setImpersonatedUser} activeUser={activeUserFullData} />}
            {activeTab === 'CreditManage' && (isAdmin || isReseller) && <CreditManageView users={users} fetchLiveData={fetchLiveData} activeUser={activeUserFullData} />}
            {activeTab === 'CreditHistory' && <CreditHistoryView creditLogs={creditLogs} activeUser={activeUserFullData} isAdmin={isAdmin} />}
            {activeTab === 'WADevices' && isAdmin && <WADevicesView />}
          </main>
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------
// LOGIN COMPONENT
// ------------------------------------------
function LoginView({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      if (res.ok) {
        const user = await res.json();
        onLogin(user);
      } else {
        setError('Invalid username or password');
      }
    } catch (err) { setError("Server connection failed. Is Backend running?"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center text-blue-600 mb-4"><MessageSquare size={48} /></div>
        <h2 className="mt-2 text-center text-3xl font-extrabold text-slate-900">Sign in to <span className="text-blue-600">WhatsApp Pro</span></h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-xl border border-slate-200 rounded-2xl sm:px-10">
          <form className="space-y-6" onSubmit={handleLogin}>
            {error && <div className="p-3 bg-red-50 text-red-700 text-sm rounded-lg border border-red-200 font-medium">{error}</div>}
            <div>
              <label className="block text-sm font-bold text-slate-700">Username</label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><User className="text-slate-400" size={18} /></div>
                <input type="text" required value={username} onChange={(e) => setUsername(e.target.value)} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-slate-300 rounded-lg py-3 bg-slate-50 border outline-none" placeholder="Enter username" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-bold text-slate-700">Password</label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><Lock className="text-slate-400" size={18} /></div>
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-slate-300 rounded-lg py-3 bg-slate-50 border outline-none" placeholder="Enter password" />
              </div>
            </div>
            <button type="submit" disabled={loading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-bold text-white bg-blue-600 hover:bg-blue-700">{loading ? 'Verifying...' : 'Sign in'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------
// SIDEBAR
// ------------------------------------------
function Sidebar({ activeTab, navigate, isMobileMenuOpen, setIsMobileMenuOpen, isAdmin, isReseller, onLogout }) {
  const menuItems = [
    { id: 'Dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { id: 'W-Campaign', icon: <Megaphone size={20} />, label: 'W-Campaign' },
    { id: 'Btn-Campaign', icon: <MousePointerClick size={20} />, label: 'Button Campaign' },
    { id: 'CreateTemplate', icon: <BookTemplate size={20} />, label: 'Create Template' },
    { id: 'CreateContact', icon: <Users size={20} />, label: 'Create Contact List' },
    { id: 'Report', icon: <FileBarChart2 size={20} />, label: 'WhatsApp Reports' },
    { id: 'CreditHistory', icon: <History size={20} />, label: 'Credit History' },
    
    ...(isAdmin || isReseller ? [
      { id: 'Users', icon: <Users size={20} />, label: 'Manage Users' },
      { id: 'CreditManage', icon: <CreditCard size={20} />, label: 'Manage Credits' }
    ] : []),

    ...(isAdmin ? [
      { id: 'WADevices', icon: <SmartphoneNfc size={20} />, label: 'WA Devices (Admin)' }
    ] : [])
  ];

  return (
    <>
      {isMobileMenuOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} />}
      <aside className={`fixed inset-y-0 left-0 z-50 w-72 bg-slate-900 text-slate-300 transition-transform duration-300 ease-in-out lg:static lg:translate-x-0 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} shadow-2xl flex flex-col`}>
        <div className="h-16 sm:h-20 flex items-center justify-between px-6 sm:px-8 bg-slate-950 border-b border-slate-800 shrink-0">
          <span className="text-xl sm:text-2xl font-black text-white flex items-center gap-2 tracking-wide"><span className="text-blue-500">WhatsApp</span> Pro</span>
          <button className="lg:hidden text-slate-400 hover:text-white p-2" onClick={() => setIsMobileMenuOpen(false)}><X size={20} /></button>
        </div>
        <nav className="flex-1 px-4 py-6 sm:py-8 space-y-1.5 sm:space-y-2 overflow-y-auto">
          {menuItems.map((item) => (
            <button key={item.id} onClick={() => navigate(item.id)} className={`w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all font-bold text-sm ${activeTab === item.id ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' : 'hover:bg-slate-800 hover:text-white text-slate-400'}`}>
              {item.icon} {item.label}
            </button>
          ))}
        </nav>
        <div className="p-4 sm:p-6 bg-slate-950 border-t border-slate-800 flex flex-col items-center shrink-0">
          <button onClick={onLogout} className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-xl hover:bg-red-500/10 text-slate-400 hover:text-red-500 transition-colors text-sm font-bold">
            <LogOut size={20} /> Logout Account
          </button>
        </div>
      </aside>
    </>
  );
}

// ------------------------------------------
// 1. DASHBOARD VIEW 
// ------------------------------------------
function DashboardView({ stats }) {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <StatCard title="Total Credits Available" value={stats.totalCreditsCombined.toLocaleString()} icon={<CreditCard size={28} />} color="bg-blue-600" />
        <StatCard title="W-Campaign Credits" value={stats.totalWCredits.toLocaleString()} icon={<ImageIcon size={28} />} color="bg-indigo-600" />
        <StatCard title="Button Credits" value={stats.totalBtnCredits.toLocaleString()} icon={<MousePointerClick size={28} />} color="bg-cyan-600" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <StatCard title="Completed Campaigns" value={stats.totalCampaigns} icon={<CheckCircle size={28} />} color="bg-emerald-500" />
        <StatCard title="Pending Approvals" value={stats.totalPending} icon={<AlertTriangle size={28} />} color="bg-amber-500" />
        <StatCard title="Processing Campaigns" value={stats.totalProcess} icon={<Settings size={28} />} color="bg-purple-500" />
      </div>
    </div>
  );
}

function StatCard({ title, value, icon, color }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 sm:p-6 flex items-center gap-4 sm:gap-5 transition-all hover:shadow-md relative overflow-hidden group">
      <div className={`absolute right-0 top-0 w-2 h-full ${color} group-hover:w-full transition-all duration-500 opacity-10`}></div>
      <div className={`${color} text-white p-3 sm:p-4 rounded-2xl shadow-lg`}>{icon}</div>
      <div>
        <p className="text-[10px] sm:text-xs font-bold text-slate-500 uppercase tracking-wider mb-0.5 sm:mb-1">{title}</p>
        <p className="text-2xl sm:text-3xl font-black text-slate-800">{value}</p>
      </div>
    </div>
  );
}

// ------------------------------------------
// 🔥 WA DEVICES VIEW (ADMIN ONLY) 🔥
// ------------------------------------------
function WADevicesView() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSessions = async () => {
      try {
         const res = await fetch(`${API_BASE}/api/wa/sessions`);
         if(res.ok) setSessions(await res.json());
      } catch(e) {}
  };
  
  useEffect(() => { 
      fetchSessions(); 
      const int = setInterval(fetchSessions, 5000); 
      return () => clearInterval(int); 
  }, []);

  const addSession = async () => {
      setLoading(true);
      try {
          await fetch(`${API_BASE}/api/wa/session/add`, {method: 'POST'});
          await fetchSessions();
      } catch(e) { alert("Make sure WA API on port 5001 is running!"); }
      setLoading(false);
  };

  const logoutSession = async (id) => {
      if(!window.confirm("Disconnect this WhatsApp Device?")) return;
      await fetch(`${API_BASE}/api/wa/session/logout/${id}`, {method: 'POST'});
      fetchSessions();
  };

  return (
     <div className="p-6 sm:p-8 bg-white rounded-2xl shadow-sm border border-slate-200 max-w-6xl mx-auto">
       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 border-b pb-4 gap-4">
         <div>
            <h2 className="text-xl sm:text-2xl font-black text-slate-800 flex items-center gap-2"><SmartphoneNfc className="text-blue-600"/> Connected WhatsApp Devices</h2>
            <p className="text-xs sm:text-sm text-slate-500 font-bold mt-1">Add devices here. The system will automatically use them to send messages and failover if one gets disconnected.</p>
         </div>
         <button onClick={addSession} disabled={loading} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-black flex items-center justify-center gap-2 shadow-lg transition-all">
           {loading ? <Loader2 className="animate-spin" size={18}/> : <Plus size={18}/>} Link New Device
         </button>
       </div>
       
       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
         {sessions.map(s => (
           <div key={s.id} className="border border-slate-200 p-5 rounded-2xl text-center shadow-sm relative overflow-hidden bg-slate-50">
             <div className="absolute top-0 left-0 w-full h-2 bg-slate-200"></div>
             <div className={`absolute top-0 left-0 w-full h-2 ${s.status === 'CONNECTED' ? 'bg-emerald-500' : s.status === 'QR_READY' ? 'bg-blue-500' : 'bg-amber-500'}`}></div>
             
             <h3 className="font-black text-base sm:text-lg text-slate-800 mb-4">{s.id}</h3>
             
             <div className="w-56 h-56 mx-auto bg-white border-2 border-dashed border-slate-300 rounded-2xl flex items-center justify-center p-2 mb-5">
                 {s.status === 'QR_READY' && s.qr && <img src={s.qr} className="w-full h-full object-contain rounded-xl" alt="qr"/>}
                 {s.status === 'CONNECTED' && <div className="flex flex-col items-center text-emerald-600"><CheckCircle size={64} className="mb-2"/><span className="font-black text-sm uppercase tracking-widest">Active & Safe</span></div>}
                 {(s.status === 'INITIALIZING' || s.status === 'DISCONNECTED' || s.status === 'FAILED') && <div className="flex flex-col items-center text-slate-500"><Loader2 className="animate-spin mb-2" size={40}/><span className="font-bold text-xs uppercase tracking-widest">{s.status}</span></div>}
             </div>
             
             <button onClick={() => logoutSession(s.id)} className="w-full bg-white border border-red-200 text-red-600 px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold hover:bg-red-50 flex justify-center items-center gap-2 transition-colors"><LogOut size={16}/> Delete Device</button>
           </div>
         ))}
         {sessions.length === 0 && <div className="col-span-full text-center text-slate-400 font-black py-16 text-lg sm:text-xl border-2 border-dashed rounded-3xl bg-slate-50">No devices connected. Click 'Link New Device' to start.</div>}
       </div>
     </div>
  );
}

// ------------------------------------------
// 2. CREATE CAMPAIGN VIEW 
// ------------------------------------------
function CreateCampaignView({ activeUser, onProcessUpload, onSuccess, savedTemplates, savedContacts, campaignType }) {
  const [formData, setFormData] = useState({ name: '', numbers: '', message: '' });
  
  const [wImages, setWImages] = useState([null, null, null, null]); 
  const [wVideo, setWVideo] = useState(null); 
  const [wPdf, setWPdf] = useState(null); 
  const [previewUrls, setPreviewUrls] = useState({ images: [null, null, null, null], video: null, pdf: null, btnMedia: null });
  const [buttonMedia, setButtonMedia] = useState(null); 
  const [actionButtons, setActionButtons] = useState({ btn1: { name: '', value: '' }, btn2: { name: '', value: '' }, btn3: { name: '', value: '' } });

  const [processedNumbers, setProcessedNumbers] = useState({ valid: [], invalid: [], duplicates: [] });
  const [isProcessingNums, setIsProcessingNums] = useState(false);
  const [error, setError] = useState(''); 

  const isDropdownLoadRef = useRef(false);
  const prevValidRef = useRef(new Set());
  const manualNumbersRef = useRef(new Set()); 

  useEffect(() => {
    const timer = setTimeout(() => {
        if (!formData.numbers) {
            setProcessedNumbers({ valid: [], invalid: [], duplicates: [] });
            prevValidRef.current.clear();
            manualNumbersRef.current.clear();
            setIsProcessingNums(false);
            return;
        }
        
        setTimeout(() => {
            const rawList = formData.numbers.split(/[\n, \t]+/).map(n => n.trim().replace(/\D/g, '')).filter(Boolean);
            const valid = []; const invalid = []; const dups = []; const seen = new Set();
            
            rawList.forEach(num => {
              let cleaned = num.length === 12 && num.startsWith('91') ? num.substring(2) : num;
              if (cleaned.length === 10) {
                if (seen.has(cleaned)) {
                   dups.push(cleaned);
                } else { 
                   seen.add(cleaned); 
                   valid.push(cleaned); 
                }
              } else { 
                 invalid.push(cleaned); 
              }
            });
            
            // 🔥 BULLETPROOF MANUAL DETECTION TRACKER 🔥
            const newlyAddedToValidation = valid.filter(v => !prevValidRef.current.has(v));
            
            if (newlyAddedToValidation.length > 5 || isDropdownLoadRef.current) {
                // Done silently. Does NOT become 'manual'.
            } else {
                newlyAddedToValidation.forEach(n => manualNumbersRef.current.add(n));
            }
            
            isDropdownLoadRef.current = false;
            prevValidRef.current = new Set(valid);
            
            setProcessedNumbers({ valid, invalid, duplicates: dups });
            setIsProcessingNums(false);
        }, 0);
    }, 500); 

    return () => clearTimeout(timer);
  }, [formData.numbers]);

  const handleNumberChange = (e) => {
    setIsProcessingNums(true);
    let val = e.target.value;
    if (e.nativeEvent && e.nativeEvent.inputType === 'insertText') {
        const lines = val.split('\n');
        const lastLine = lines[lines.length - 1];
        if (/^\d{10}$/.test(lastLine.trim())) { val = val + '\n'; }
    }
    setFormData({...formData, numbers: val});
  };

  const handleMediaChange = (e, type, index = null) => {
    const file = e.target.files[0]; setError('');
    if (!file) return;

    let maxSizeMB = 1;
    if (type === 'wVideo') maxSizeMB = 5;
    if (type === 'wPdf' || file.type.includes('pdf')) maxSizeMB = 3;

    if (file.size > maxSizeMB * 1024 * 1024) {
      alert(`System Error: File size must be under ${maxSizeMB}MB. Please re-upload.`);
      e.target.value = '';
      return;
    }

    if (type === 'wImage') {
      const newImages = [...wImages]; newImages[index] = file; setWImages(newImages);
      const newUrls = [...previewUrls.images]; newUrls[index] = URL.createObjectURL(file);
      setPreviewUrls(prev => ({ ...prev, images: newUrls }));
    } else if (type === 'wVideo') {
      setWVideo(file); setPreviewUrls(prev => ({ ...prev, video: URL.createObjectURL(file) }));
    } else if (type === 'wPdf') {
      setWPdf(file); setPreviewUrls(prev => ({ ...prev, pdf: URL.createObjectURL(file) }));
    } else if (type === 'btnMedia') {
      setButtonMedia(file); setPreviewUrls(prev => ({ ...prev, btnMedia: URL.createObjectURL(file) }));
    }
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve({name: file.name, url: reader.result});
    reader.onerror = error => reject(error);
  });

  const resetForm = () => {
      setFormData({ name: '', numbers: '', message: '' });
      setWImages([null, null, null, null]);
      setWVideo(null);
      setWPdf(null);
      setPreviewUrls({ images: [null, null, null, null], video: null, pdf: null, btnMedia: null });
      setButtonMedia(null);
      setActionButtons({ btn1: { name: '', value: '' }, btn2: { name: '', value: '' }, btn3: { name: '', value: '' } });
      setProcessedNumbers({ valid: [], invalid: [], duplicates: [] });
      prevValidRef.current.clear();
      manualNumbersRef.current.clear();
      isDropdownLoadRef.current = false;
      setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || processedNumbers.valid.length === 0 || !formData.message) {
      setError('Campaign Name, Target Numbers, and Message Content are mandatory.'); return;
    }

    const cost = processedNumbers.valid.length; 
    if (activeUser.role !== 'Admin') {
      if (campaignType === 'w-campaign' && activeUser.wBalance < cost) { setError(`Not enough W Credits.`); return; }
      if (campaignType === 'button-campaign' && activeUser.btnBalance < cost) { setError(`Not enough Button Credits.`); return; }
    }

    try {
        const imagesB64 = [];
        for(let img of wImages) { if(img) imagesB64.push(await fileToBase64(img)); }
        const videoB64 = wVideo ? await fileToBase64(wVideo) : null;
        const pdfB64 = wPdf ? await fileToBase64(wPdf) : null;
        const btnMediaB64 = buttonMedia ? await fileToBase64(buttonMedia) : null;

        const campaignMedia = {
          images: imagesB64.length > 0 ? imagesB64 : null,
          video: videoB64, pdf: pdfB64, btnMedia: btnMediaB64, buttons: actionButtons
        };

        const manuallyTypedFinal = processedNumbers.valid.filter(num => manualNumbersRef.current.has(num));
        const validWA = []; const invalidWA = [];
        processedNumbers.valid.forEach(num => { if (isWhatsAppNumber(num)) validWA.push(num); else invalidWA.push(num); });

        const newCampObj = {
          userId: activeUser.id, userName: activeUser.username,
          name: formData.name, numberCount: processedNumbers.valid.length, numbersList: processedNumbers.valid, 
          manualNumbers: manuallyTypedFinal, validNumbers: validWA, invalidNumbers: [...invalidWA, ...processedNumbers.invalid],
          manualCount: manuallyTypedFinal.length,
          validCount: validWA.length,
          invalidCount: invalidWA.length + processedNumbers.invalid.length,
          status: 'Pending', date: new Date().toLocaleString(), type: campaignType,
          message: formData.message, media: campaignMedia
        };

        onProcessUpload(newCampObj, cost, campaignType);

        alert("Campaign Send Successfully");
        resetForm();
        onSuccess(); 

    } catch (err) {
        setError("Error preparing files. Please try again.");
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 h-full items-start">
      <div className="lg:col-span-8 bg-white shadow-lg rounded-3xl border border-slate-200 overflow-hidden flex flex-col relative order-2 lg:order-1">
        <div className="h-2 w-full bg-blue-600"></div>
        <div className="p-5 sm:p-6 border-b border-slate-200 bg-slate-50/50">
          <h2 className="text-xl sm:text-2xl font-black text-slate-800">Create {campaignType === 'w-campaign' ? 'W-Campaign' : 'Button Campaign'}</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-5 sm:p-8 space-y-6 sm:space-y-8">
          {error && <div className="p-3 sm:p-4 bg-red-50 text-red-700 rounded-xl border border-red-200 text-xs sm:text-sm font-bold flex items-center gap-3"><AlertTriangle size={20} className="shrink-0"/> {error}</div>}
          
          <div className="space-y-6 sm:space-y-8">
            <div>
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-2">Campaign Name *</label>
              <input type="text" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="w-full px-4 sm:px-5 py-3 bg-slate-50 border border-slate-300 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none text-sm font-medium transition-all shadow-sm" placeholder="e.g. Summer Sale 2026" />
            </div>

            <div>
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-2 gap-2">
                <label className="block text-xs sm:text-sm font-bold text-slate-700">Target Numbers (10 Digits) *</label>
                
                <select className="text-[10px] sm:text-xs border border-blue-200 bg-blue-50 text-blue-700 font-bold py-1.5 px-3 rounded-lg cursor-pointer outline-none hover:bg-blue-100 transition-colors shadow-sm w-full sm:w-auto" onChange={(e) => { 
                    if(e.target.value) { 
                      const contact = savedContacts.find(c => c.id == e.target.value);
                      if(contact) {
                         setIsProcessingNums(true);
                         isDropdownLoadRef.current = true;
                         const combined = formData.numbers ? formData.numbers + '\n' + contact.numbers : contact.numbers;
                         setFormData({...formData, numbers: combined});
                      }
                    } 
                  }}>
                  <option value="">+ Load Contact List</option>
                  {savedContacts.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <textarea rows="5" required value={formData.numbers} onChange={handleNumberChange} className="w-full px-4 sm:px-5 py-3 sm:py-4 bg-slate-50 border border-slate-300 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none text-sm font-mono transition-all shadow-sm leading-relaxed" placeholder="Type or paste 10-digit numbers here..."></textarea>
              
              <div className="flex flex-wrap gap-2 sm:gap-4 mt-3">
                {isProcessingNums ? (
                    <span className="px-3 py-1 bg-blue-50 text-blue-700 font-bold rounded-lg text-xs flex items-center gap-2"><Loader2 size={12} className="animate-spin"/> Parsing Numbers...</span>
                ) : (
                  <>
                    <span className="px-2 sm:px-3 py-1 bg-emerald-50 border border-emerald-200 text-emerald-700 font-bold rounded-lg text-[10px] sm:text-xs flex items-center gap-1"><CheckCircle size={12}/> Valid: {processedNumbers.valid.length}</span>
                    {activeUser.role === 'Admin' && (
                      <span className="px-2 sm:px-3 py-1 bg-blue-50 border border-blue-200 text-blue-700 font-bold rounded-lg text-[10px] sm:text-xs flex items-center gap-1"><User size={12}/> Manual: {processedNumbers.valid.filter(n => manualNumbersRef.current.has(n)).length}</span>
                    )}
                    <span className="px-2 sm:px-3 py-1 bg-red-50 border border-red-200 text-red-700 font-bold rounded-lg text-[10px] sm:text-xs flex items-center gap-1"><AlertTriangle size={12}/> Invalid: {processedNumbers.invalid.length}</span>
                    <span className="px-2 sm:px-3 py-1 bg-slate-100 border border-slate-300 text-slate-700 font-bold rounded-lg text-[10px] sm:text-xs">Duplicate: {processedNumbers.duplicates.length}</span>
                  </>
                )}
              </div>
            </div>

            <div>
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-2 gap-2">
                <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1 flex justify-between w-full">
                   <span>Message Content *</span>
                   <span className={formData.message.length >= 1000 ? 'text-red-600' : 'text-slate-500'}>({formData.message.length}/1000)</span>
                </label>
                <select className="text-[10px] sm:text-xs border border-indigo-200 bg-indigo-50 text-indigo-700 font-bold py-1.5 px-3 rounded-lg cursor-pointer outline-none hover:bg-indigo-100 transition-colors shadow-sm w-full sm:w-auto mt-2 sm:mt-0" onChange={(e) => { 
                    if(e.target.value) { 
                      const txt = savedTemplates.find(c => c.id == e.target.value)?.text; 
                      if(txt) {
                          let finalTxt = txt;
                          if(finalTxt.length > 1000) {
                              setError('❌ Template text exceeds 1000 characters. Extra text removed.');
                              finalTxt = finalTxt.substring(0, 1000);
                          } else {
                              if(error.includes('1000')) setError('');
                          }
                          setFormData(prev => ({...prev, message: finalTxt})); 
                      }
                    } 
                  }}>
                  <option value="">+ Insert Template</option>
                  {savedTemplates.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              
              <textarea 
                  rows="6" 
                  required 
                  value={formData.message} 
                  onChange={e => {
                      let val = e.target.value;
                      if(val.length > 1000) {
                          setError('❌ Message limit reached! Maximum 1000 characters allowed. Extra text has been removed.');
                          val = val.substring(0, 1000);
                      } else {
                          if(error.includes('1000')) setError('');
                      }
                      setFormData({...formData, message: val});
                  }} 
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 bg-slate-50 border border-slate-300 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none text-sm transition-all shadow-sm" 
                  placeholder="Type your WhatsApp message... (Max 1000 Characters)"
              ></textarea>
            </div>
          </div>
          
          <div className="bg-slate-50 p-4 sm:p-6 rounded-2xl sm:rounded-3xl border border-slate-200 shadow-inner">
            {campaignType === 'w-campaign' ? (
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-center gap-2 sm:gap-3 border-b border-slate-300 pb-2 sm:pb-3"><ImageIcon size={18} className="text-blue-600"/> <h3 className="text-sm sm:text-base font-black text-slate-800">Media Slots</h3></div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                  {[0,1,2,3].map(i => (
                    <div key={i} className="bg-white border-2 border-dashed border-slate-300 rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center relative hover:border-blue-50 hover:bg-blue-50 transition-all shadow-sm h-28 sm:h-auto flex flex-col justify-center items-center">
                      <input type="file" accept="image/*" onChange={(e) => handleMediaChange(e, 'wImage', i)} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" />
                      {wImages[i] ? (<div className="text-[10px] sm:text-xs text-blue-700 font-bold truncate px-1 w-full">{wImages[i].name}</div>) : (<div className="text-xs sm:text-sm text-slate-500 font-bold flex flex-col items-center gap-1"><Plus size={16} className="text-slate-400"/> Image {i+1}<span className="text-[9px] sm:text-[10px] text-slate-400 font-normal">(1 MB)</span></div>)}
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-slate-300">
                  <div>
                    <div className="bg-white border-2 border-dashed border-slate-300 rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center relative h-28 sm:h-auto flex flex-col justify-center items-center"><input type="file" accept="video/*" onChange={(e) => handleMediaChange(e, 'wVideo')} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"/>{wVideo ? (<div className="text-[10px] sm:text-xs text-indigo-700 font-bold truncate px-1 w-full">{wVideo.name}</div>) : (<div className="text-xs sm:text-sm font-bold text-slate-500 flex flex-col items-center gap-1"><Video size={16} className="text-indigo-400"/> Add Video<span className="text-[9px] sm:text-[10px] text-slate-400 font-normal">(5 MB)</span></div>)}</div>
                  </div>
                  <div>
                    <div className="bg-white border-2 border-dashed border-slate-300 rounded-xl sm:rounded-2xl p-3 sm:p-4 text-center relative h-28 sm:h-auto flex flex-col justify-center items-center"><input type="file" accept=".pdf" onChange={(e) => handleMediaChange(e, 'wPdf')} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"/>{wPdf ? (<div className="text-[10px] sm:text-xs text-red-700 font-bold truncate px-1 w-full">{wPdf.name}</div>) : (<div className="text-xs sm:text-sm font-bold text-slate-500 flex flex-col items-center gap-1"><FileText size={16} className="text-red-400"/> Add PDF<span className="text-[9px] sm:text-[10px] text-slate-400 font-normal">(3 MB)</span></div>)}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-4 sm:space-y-6">
                <div className="flex items-center gap-2 sm:gap-3 border-b border-slate-300 pb-2 sm:pb-3"><MousePointerClick size={18} className="text-blue-600"/> <h3 className="text-sm sm:text-base font-black text-slate-800">Button Campaign Config</h3></div>
                <div>
                  <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-2 sm:mb-3">Header Media (Image: 1MB, Video: 5MB, PDF: 3MB)</label>
                  <input type="file" accept="image/*,video/*,.pdf" onChange={(e) => handleMediaChange(e, 'btnMedia')} className="block w-full text-[10px] sm:text-sm text-slate-600 bg-white rounded-xl p-1.5 sm:p-2 shadow-sm border border-slate-200 cursor-pointer file:mr-2 sm:file:mr-4 file:py-1.5 sm:file:py-2 file:px-3 sm:file:px-4 file:rounded-lg file:border-0 file:text-[10px] sm:file:text-sm file:font-bold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                </div>
                <div className="space-y-2 sm:space-y-3 pt-1 sm:pt-2">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
                    <div className="font-bold text-slate-700 w-full sm:w-32 shrink-0 flex items-center gap-2 text-xs sm:text-sm"><Phone size={14} className="text-blue-500"/> Call Now</div>
                    <input type="text" placeholder="Enter Mobile Number" value={actionButtons.btn1.value} onChange={e=>setActionButtons({...actionButtons, btn1: {name: 'Call Now', value: e.target.value}})} className="flex-1 bg-slate-50 border rounded-lg px-3 py-2 outline-none text-xs sm:text-sm w-full"/>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
                    <div className="font-bold text-slate-700 w-full sm:w-32 shrink-0 flex items-center gap-2 text-xs sm:text-sm"><LinkIcon size={14} className="text-emerald-500"/> Visit Now</div>
                    <input type="text" placeholder="Enter Website Link" value={actionButtons.btn2.value} onChange={e=>setActionButtons({...actionButtons, btn2: {name: 'Visit Now', value: e.target.value}})} className="flex-1 bg-slate-50 border rounded-lg px-3 py-2 outline-none text-xs sm:text-sm w-full"/>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
                    <input type="text" placeholder="Custom Title" value={actionButtons.btn3.name} onChange={e=>setActionButtons({...actionButtons, btn3: {...actionButtons.btn3, name: e.target.value}})} className="w-full sm:w-32 shrink-0 bg-slate-50 border rounded-lg px-3 py-2 outline-none text-xs sm:text-sm font-bold"/>
                    <input type="text" placeholder="Enter Link/Value" value={actionButtons.btn3.value} onChange={e=>setActionButtons({...actionButtons, btn3: {...actionButtons.btn3, value: e.target.value}})} className="flex-1 bg-slate-50 border rounded-lg px-3 py-2 outline-none text-xs sm:text-sm w-full"/>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="pt-6 sm:pt-8 flex justify-end">
            <button type="submit" disabled={isProcessingNums} className={`w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-8 sm:px-12 py-3.5 sm:py-4 rounded-xl shadow-xl shadow-blue-600/30 font-black flex items-center justify-center gap-2 sm:gap-3 transition-all text-base sm:text-lg active:scale-95 ${isProcessingNums && 'opacity-50 cursor-not-allowed'}`}><Megaphone size={20} /> Send Campaign Now</button>
          </div>
        </form>
      </div>

      <div className="lg:col-span-4 lg:sticky lg:top-6 w-full max-w-[340px] mx-auto order-1 lg:order-2 mb-6 lg:mb-0">
        <div className="bg-slate-200 rounded-[2.5rem] border-8 border-slate-800 p-2 relative h-[500px] sm:h-[650px] shadow-2xl flex flex-col">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 sm:w-32 h-4 sm:h-6 bg-slate-800 rounded-b-xl sm:rounded-b-2xl z-10"></div>
          
          <div className="bg-[#075E54] px-4 py-6 sm:py-8 pb-3 sm:pb-4 rounded-t-3xl text-white font-bold flex items-center gap-3 shadow-md">
             <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-full flex items-center justify-center"><Smartphone size={18}/></div>
             <div className="leading-tight">
               <div className="text-[13px] sm:text-[15px]">Live Preview</div>
               <div className="text-[9px] sm:text-[10px] font-normal opacity-80">{campaignType === 'w-campaign' ? 'W-Campaign' : 'Button Campaign'}</div>
             </div>
          </div>
          
          <div className="flex-1 bg-[#E5DDD5] p-3 sm:p-4 overflow-y-auto flex flex-col rounded-b-3xl relative">
             <div className="absolute inset-0 opacity-40 pointer-events-none mix-blend-overlay" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")'}}></div>
             
             <div className="bg-white p-2 rounded-2xl rounded-tl-none shadow-sm text-[13px] sm:text-[15px] text-[#111B21] max-w-[90%] self-start relative mt-3 sm:mt-4 z-10 break-words">
                {campaignType === 'w-campaign' && previewUrls.images[0] && <img src={previewUrls.images[0]} className="w-full h-32 sm:h-40 object-cover rounded-xl mb-2" alt="img"/>}
                {campaignType === 'w-campaign' && previewUrls.video && <div className="w-full h-20 sm:h-24 bg-slate-800 flex items-center justify-center font-bold text-white mb-2 rounded-xl"><Video size={20}/></div>}
                {campaignType === 'w-campaign' && previewUrls.pdf && <div className="w-full bg-red-50 border border-red-100 p-2 sm:p-3 flex items-center gap-1.5 sm:gap-2 font-bold text-red-600 mb-2 rounded-xl text-[10px] sm:text-xs"><FileText size={14}/> Attached PDF</div>}
                
                {campaignType === 'button-campaign' && previewUrls.btnMedia && <div className="w-full h-24 sm:h-32 bg-slate-200 flex items-center justify-center font-bold text-slate-500 mb-2 rounded-xl overflow-hidden"><img src={previewUrls.btnMedia} className="w-full h-full object-cover" alt="header media"/></div>}
                
                <p className="whitespace-pre-wrap font-sans leading-snug pb-3">{formData.message || "Your typed message will appear here live..."}</p>
                <span className="text-[9px] sm:text-[10px] text-slate-400 absolute bottom-1.5 right-2.5">12:00 PM</span>
             </div>

             {/* 🔥 BUTTONS PREVIEW AS TEXT LINKS 🔥 */}
             {campaignType === 'button-campaign' && (actionButtons.btn1.value || actionButtons.btn2.value || actionButtons.btn3.name) && (
                <div className="bg-white p-2.5 mt-2 rounded-xl shadow-sm text-[#111B21] max-w-[90%] self-start z-10 text-[13px] sm:text-[15px] leading-relaxed break-words">
                   <div className="font-bold text-slate-800 mb-2 tracking-[0.2em] text-[14px]">_ _ _ _ _ _ _ _</div>
                   {actionButtons.btn1.value && <div className="mb-2">📞 <b>{actionButtons.btn1.name || 'Call Now'}</b><br/><span className="text-blue-600">👉 <u>{actionButtons.btn1.value}</u></span></div>}
                   {actionButtons.btn2.value && <div className="mb-2">🌐 <b>{actionButtons.btn2.name || 'Visit Now'}</b><br/><span className="text-blue-600">👉 <u>{actionButtons.btn2.value}</u></span></div>}
                   {actionButtons.btn3.name && <div>✨ <b>{actionButtons.btn3.name}</b><br/><span className="text-blue-600">👉 <u>{actionButtons.btn3.value}</u></span></div>}
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------
// 3. WHATSAPP REPORT VIEW 
// ------------------------------------------
function ReportView({ campaigns, isAdmin, users, fetchLiveData, navigate }) {
  const [expandedRows, setExpandedRows] = useState(new Set());
  
  const [smartFilterData, setSmartFilterData] = useState(null);
  const [mergeConfig, setMergeConfig] = useState({ isOpen: false, camp: null, remainingSentPct: 100, pastedData: '' });
  
  const [activeDevices, setActiveDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState(['All']);

  const [mediaCache, setMediaCache] = useState({});
  const [loadingMedia, setLoadingMedia] = useState(new Set());
  const [isActionLoading, setIsActionLoading] = useState(false);

  const loadMediaForCampaign = async (campId) => {
      if(String(campId).startsWith('temp')) return; 
      if(mediaCache[campId] !== undefined) return; 
      setLoadingMedia(prev => new Set(prev).add(campId));
      try {
          const res = await fetch(`${API_BASE}/api/campaigns/${campId}/media`);
          if(res.ok) {
              const data = await res.json();
              let parsedMedia = data.media;
              try { while(typeof parsedMedia === 'string') { parsedMedia = JSON.parse(parsedMedia); } } catch(e) {}
              setMediaCache(prev => ({...prev, [campId]: parsedMedia || null}));
          } else { setMediaCache(prev => ({...prev, [campId]: null})); }
      } catch(e) { setMediaCache(prev => ({...prev, [campId]: null})); }
      setLoadingMedia(prev => { const next = new Set(prev); next.delete(campId); return next; });
  };

  const toggleRow = (id) => {
    const newSet = new Set(expandedRows);
    if (newSet.has(id)) { newSet.delete(id); } else { newSet.add(id); loadMediaForCampaign(id); }
    setExpandedRows(newSet);
  };

  const executeDownload = (filename, dataArray) => {
      if(dataArray.length === 0) return;
      let csvContent = `data:text/csv;charset=utf-8,Mobile_Number\n` + dataArray.join('\n');
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a"); link.setAttribute("href", encodedUri); link.setAttribute("download", filename);
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
  };

  const handleListDownload = async (camp, type) => {
      if(camp.isVirtual) { alert("Please wait for background processing."); return; }
      try {
          const res = await fetch(`${API_BASE}/api/campaigns/${camp.id}/data`);
          const data = await res.json();
          let parsedList = [];
          
          if(type === 'total') {
              let arr1 = [], arr2 = [];
              try{ arr1=JSON.parse(data.numbersList||'[]'); arr2=JSON.parse(data.manualNumbers||'[]'); }catch(e){}
              parsedList = [...new Set([...arr1, ...arr2])];
              executeDownload(`Total_${camp.name}.csv`, parsedList);
          } else if (type === 'manual') {
              try{ parsedList=JSON.parse(data.manualNumbers||'[]'); }catch(e){}
              executeDownload(`Manual_${camp.name}.csv`, parsedList);
          } else if (type === 'valid') {
              try{ parsedList=JSON.parse(data.validNumbers||'[]'); }catch(e){}
              executeDownload(`Valid_WA_${camp.name}.csv`, parsedList);
          } else if (type === 'invalid') {
              try{ parsedList=JSON.parse(data.invalidNumbers||'[]'); }catch(e){}
              executeDownload(`Invalid_NonWA_${camp.name}.csv`, parsedList);
          } else if(type === 'apiReport') {
              try {
                  const apiData = JSON.parse(data.apiReport || '[]');
                  if(apiData.length === 0) { alert("No API report found. Was it sent live?"); return; }
                  let csvContent = `data:text/csv;charset=utf-8,Mobile_Number,Status\n` + apiData.map(r => `${r.number},${r.status}`).join('\n');
                  const link = document.createElement("a"); link.setAttribute("href", encodeURI(csvContent)); link.setAttribute("download", `API_Report_${camp.name}.csv`);
                  document.body.appendChild(link); link.click(); document.body.removeChild(link);
              } catch(e) { alert("Failed to generate API report."); }
          }
      } catch(e) { alert("Failed to download data."); }
  };

  const fetchDevices = async () => {
      try {
          const res = await fetch(`${API_BASE}/api/wa/sessions`);
          if(res.ok) {
              const data = await res.json();
              setActiveDevices(data.filter(d => d.status === 'CONNECTED'));
          }
      } catch(e){}
  };

  const openSmartFilter = async (camp) => {
      setIsActionLoading(true);
      try {
          await fetchDevices(); 
          
          const dataRes = await fetch(`${API_BASE}/api/campaigns/${camp.id}/data`);
          const data = await dataRes.json();
          const mediaRes = await fetch(`${API_BASE}/api/campaigns/${camp.id}/media`);
          const mediaData = await mediaRes.json();
          
          let arr1 = [], arr2 = [];
          try{ arr1=JSON.parse(data.numbersList||'[]'); arr2=JSON.parse(data.manualNumbers||'[]'); }catch(e){}
          
          const allNums = [...new Set([...arr1, ...arr2])].filter(n => isWhatsAppNumber(n));
          const manualNums = arr2.filter(n => isWhatsAppNumber(n)); 
          
          setSmartFilterData({
              campId: camp.id, campName: camp.name, message: camp.message, media: mediaData.media,
              allNums: allNums, manualNums: manualNums, sendPercentage: 20, numbersText: ''
          });
          setSelectedDevices(['All']); 
      } catch(e) { alert("Error loading campaign data."); } 
      finally { setIsActionLoading(false); }
  };

  useEffect(() => {
      if(smartFilterData && smartFilterData.allNums) {
          const total = smartFilterData.allNums.length;
          
          const manualSet = new Set(smartFilterData.manualNums || []);
          const normalNums = smartFilterData.allNums.filter(n => !manualSet.has(n));

          let targetCount = Math.ceil(total * (smartFilterData.sendPercentage / 100));
          if(targetCount === 0 && total > 0) targetCount = 1;

          let finalSelection = [...smartFilterData.manualNums];
          let remainingNeeded = targetCount - finalSelection.length;

          if (remainingNeeded > 0 && normalNums.length > 0) {
              let topCount = Math.ceil(remainingNeeded * 0.20);
              let bottomCount = Math.ceil(remainingNeeded * 0.20);
              let midCount = remainingNeeded - topCount - bottomCount;
              if(midCount < 0) midCount = 0;

              let topArr = normalNums.slice(0, topCount);
              let bottomArr = normalNums.slice(-bottomCount);
              let midPool = normalNums.slice(topCount, normalNums.length - bottomCount);
              
              let shuffledMid = [...midPool];
              for (let i = shuffledMid.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [shuffledMid[i], shuffledMid[j]] = [shuffledMid[j], shuffledMid[i]];
              }
              let midArr = shuffledMid.slice(0, midCount);

              finalSelection = [...new Set([...finalSelection, ...topArr, ...midArr, ...bottomArr])];
          }

          setSmartFilterData(prev => ({...prev, numbersText: finalSelection.join('\n')}));
      }
  }, [smartFilterData?.sendPercentage]);

  const executeSmartSend = async () => {
      setIsActionLoading(true);
      try {
           const nums = smartFilterData.numbersText.split(/[\n,]+/).map(n => n.trim()).filter(Boolean);
           
           let mediaList = [];
           let parsedMedia = smartFilterData.media;
           try { while(typeof parsedMedia === 'string') parsedMedia = JSON.parse(parsedMedia); } catch(e){}
           
           if(parsedMedia) {
               if(parsedMedia.images) parsedMedia.images.forEach(img => {
                   const mime = img.url.split(';')[0].replace('data:', '');
                   const b64 = img.url.split(',')[1];
                   mediaList.push({ mimetype: mime, data: b64, filename: img.name });
               });
               if(parsedMedia.video) {
                   const mime = parsedMedia.video.url.split(';')[0].replace('data:', '');
                   const b64 = parsedMedia.video.url.split(',')[1];
                   mediaList.push({ mimetype: mime, data: b64, filename: parsedMedia.video.name || 'video.mp4' });
               }
               if(parsedMedia.pdf) {
                   const mime = parsedMedia.pdf.url.split(';')[0].replace('data:', '');
                   const b64 = parsedMedia.pdf.url.split(',')[1];
                   mediaList.push({ mimetype: mime, data: b64, filename: parsedMedia.pdf.name || 'document.pdf' });
               }
               if(parsedMedia.btnMedia) {
                   const mime = parsedMedia.btnMedia.url.split(';')[0].replace('data:', '');
                   const b64 = parsedMedia.btnMedia.url.split(',')[1];
                   mediaList.push({ mimetype: mime, data: b64, filename: parsedMedia.btnMedia.name || 'header.jpg' });
               }
           }

           const waRes = await fetch(`${API_BASE}/api/wa/send-smart`, {
               method: 'POST', headers:{'Content-Type':'application/json'},
               body: JSON.stringify({ 
                   campId: smartFilterData.campId, 
                   numbers: nums, 
                   message: smartFilterData.message, 
                   mediaList: mediaList, 
                   buttons: parsedMedia?.buttons,
                   selectedDevices: selectedDevices,
                   manualNums: smartFilterData.manualNums 
               })
           });
           
           if(waRes.ok) {
               await fetch(`${API_BASE}/api/campaigns/${smartFilterData.campId}/live-update`, { 
                   method: 'PUT', headers: { 'Content-Type': 'application/json' }, 
                   body: JSON.stringify({ status: 'Sending Live...', apiTargetCount: nums.length }) 
               });
               setSmartFilterData(null);
               fetchLiveData();
           } else { alert("Error starting WA API. Are the devices connected?"); }
      } catch(e) { alert("Network error connecting to WA API."); } 
      finally { setIsActionLoading(false); }
  };

  const handleStopCampaign = async (campId) => {
    if(!window.confirm("Stop this campaign? The current number will be completed and the campaign will move to Report Processing.")) return;
    setIsActionLoading(true);
    try {
        await fetch(`${API_BASE}/api/wa/stop/${campId}`, { method: 'POST' });
        fetchLiveData();
    } catch(e) { console.error("Error stopping campaign", e); }
    finally { setIsActionLoading(false); }
  };

  const handlePauseCampaign = async (campId) => {
    setIsActionLoading(true);
    try {
        await fetch(`${API_BASE}/api/wa/pause/${campId}`, { method: 'POST' });
        fetchLiveData();
    } catch(e) { console.error("Error pausing campaign", e); }
    finally { setIsActionLoading(false); }
  };

  const handleResumeCampaign = async (campId) => {
    setIsActionLoading(true);
    try {
        await fetch(`${API_BASE}/api/wa/resume/${campId}`, { method: 'POST' });
        fetchLiveData();
    } catch(e) { console.error("Error resuming campaign", e); }
    finally { setIsActionLoading(false); }
  };

  const handleAdminAction = async (campId, actionType) => {
    if(isActionLoading) return;
    const campaign = campaigns.find(c => c.id === campId);
    if (!campaign) return;

    if(actionType === 'Process') { openSmartFilter(campaign); return; }
    if(actionType === 'Reject') setIsActionLoading(true);

    try {
        if (actionType === 'Reject') {
          const costToRefund = campaign.numberCount;
          const targetUser = users.find(u => u.id === campaign.userId);
          
          if (targetUser && targetUser.role !== 'Admin') {
             await fetch(`${API_BASE}/api/users/update-credit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId: targetUser.id, wBalance: campaign.type === 'w-campaign' ? costToRefund : 0, btnBalance: campaign.type === 'button-campaign' ? costToRefund : 0 }) });
             await fetch(`${API_BASE}/api/credit-logs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId: targetUser.id, username: targetUser.username, walletType: campaign.type === 'w-campaign' ? 'W Credit' : 'Button Credit', type: 'Refund', amount: costToRefund, date: new Date().toLocaleString(), note: `Full Refund (Rejected)`, campaignName: campaign.name }) });
          }
          await fetch(`${API_BASE}/api/campaigns/${campId}/live-update`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'Failed' }) });
          alert(`Campaign Rejected. ${costToRefund} credits refunded to user.`);
          fetchLiveData();
        } 
    } finally { setIsActionLoading(false); }
  };

  const executeFinalMerge = async () => {
      setIsActionLoading(true);
      try {
          const campaign = mergeConfig.camp;
          
          const pastedMap = new Map();
          if (mergeConfig.pastedData.trim() !== '') {
              mergeConfig.pastedData.split('\n').forEach(line => {
                  const parts = line.split(/[, \t]+/); 
                  if (parts.length >= 2) { 
                      const num = String(parts[0]).replace(/\D/g, '');
                      const cleanNum = (num.length === 12 && num.startsWith('91')) ? num.substring(2) : num;
                      const status = parts[1].trim(); 
                      if (cleanNum && status) pastedMap.set(cleanNum, status); 
                  }
              });
          }

          const res = await fetch(`${API_BASE}/api/campaigns/${campaign.id}/data`);
          const dbData = await res.json();
          let arr1 = [], arr2 = [], invalidOriginal = [];
          try{ arr1=JSON.parse(dbData.numbersList||'[]'); arr2=JSON.parse(dbData.manualNumbers||'[]'); }catch(e){}
          try{ invalidOriginal=JSON.parse(dbData.invalidNumbers||'[]'); }catch(e){}
          
          const allCampaignNumbers = [...new Set([...arr1, ...arr2])];
          
          let finalReport = [];
          let remainingForGeneration = [];

          allCampaignNumbers.forEach(rawNum => {
              const cleanNum = String(rawNum).replace(/\D/g, '');
              const checkNum = (cleanNum.length === 12 && cleanNum.startsWith('91')) ? cleanNum.substring(2) : cleanNum;

              if (invalidOriginal.includes(rawNum) || !isWhatsAppNumber(checkNum)) { finalReport.push({ number: rawNum, status: 'Failed' }); } 
              else if (pastedMap.has(checkNum)) { finalReport.push({ number: rawNum, status: pastedMap.get(checkNum) }); } 
              else { remainingForGeneration.push(rawNum); }
          });

          const shuffledRemaining = [...remainingForGeneration];
          for (let i = shuffledRemaining.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [shuffledRemaining[i], shuffledRemaining[j]] = [shuffledRemaining[j], shuffledRemaining[i]];
          }
          
          const targetSent = Math.floor(shuffledRemaining.length * (mergeConfig.remainingSentPct / 100));
          
          shuffledRemaining.forEach((num, index) => {
              if(index < targetSent) finalReport.push({ number: num, status: 'Sent' });
              else finalReport.push({ number: num, status: 'Failed' });
          });

          const failedCount = finalReport.filter(r => r.status === 'Failed' || r.status.toLowerCase() === 'failed').length;
          const targetUser = users.find(u => u.id === campaign.userId);

          if (failedCount > 0 && targetUser && targetUser.role !== 'Admin') {
               await fetch(`${API_BASE}/api/users/update-credit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId: targetUser.id, wBalance: campaign.type === 'w-campaign' ? failedCount : 0, btnBalance: campaign.type === 'button-campaign' ? failedCount : 0 }) });
               await fetch(`${API_BASE}/api/credit-logs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId: targetUser.id, username: targetUser.username, walletType: campaign.type === 'w-campaign' ? 'W Credit' : 'Button Credit', type: 'Refund', amount: failedCount, date: new Date().toLocaleString(), note: `Refund for Failed SMS`, campaignName: campaign.name }) });
          }

          await fetch(`${API_BASE}/api/campaigns/${campaign.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'Complete', finalReport: finalReport }) });
          setMergeConfig({ isOpen: false, camp: null, remainingSentPct: 100, pastedData: '' });
          alert(`Master Merge Complete! Final Report Generated. ${failedCount > 0 ? failedCount + ' credits refunded for failed SMS.' : '100% was sent.'}`);
          fetchLiveData();

      } catch(e) { alert("Error generating merged report."); }
      finally { setIsActionLoading(false); }
  };

  const handleDownload = async (campId, campName) => {
    try {
        const res = await fetch(`${API_BASE}/api/campaigns/${campId}/data`);
        const data = await res.json();
        let fReport = [];
        try{ fReport=JSON.parse(data.finalReport||'[]'); }catch(e){}
        if (fReport.length > 0) {
          let csvContent = "Number,Status,Date\n";
          fReport.forEach(r => { csvContent += `${maskNumber(r.number)},${r.status},${new Date().toLocaleDateString()}\n`; });
          const link = document.createElement("a"); link.setAttribute("href", encodeURI(`data:text/csv;charset=utf-8,${csvContent}`)); link.setAttribute("download", `Report_${campName}.csv`);
          document.body.appendChild(link); link.click(); document.body.removeChild(link);
        }
    } catch(e) { alert("Error downloading report."); }
  };

  return (
    <div className="bg-white shadow-md rounded-2xl border border-slate-200 overflow-hidden relative">
      {isAdmin && <div className="absolute top-14 sm:top-12 right-4 flex items-center gap-2 text-[10px] sm:text-xs font-bold text-blue-600 bg-blue-50 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg border border-blue-100 z-10"><span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-500 rounded-full animate-pulse"></span> DB Auto-Sync</div>}

      <div className="bg-red-50 text-red-700 text-xs sm:text-[13px] font-bold py-2 sm:py-2.5 px-3 sm:px-4 border-b border-red-200 flex items-center gap-2 sm:gap-3">
        <AlertTriangle size={16} className="shrink-0 animate-pulse"/>
        <marquee scrollamount="5" className="font-medium tracking-wide">
          ATTENTION: All campaign data and reports will be <strong className="font-black underline">automatically and permanently deleted</strong> 15 days after the campaign creation date
        </marquee>
      </div>

      {smartFilterData && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden border border-slate-300 flex flex-col">
            <div className="bg-slate-900 px-4 sm:px-6 py-4 flex justify-between items-center shrink-0">
              <h3 className="text-white font-black text-lg flex items-center gap-2"><Settings className="text-blue-400"/> Admin Smart Sender</h3>
              <button onClick={() => setSmartFilterData(null)} disabled={isActionLoading} className="text-slate-400 hover:text-white"><X size={20}/></button>
            </div>
            
            <div className="p-5 sm:p-6 overflow-y-auto bg-slate-50 flex-1">
              
              <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4 mb-4 shadow-sm">
                 <label className="block text-sm font-black text-indigo-900 mb-3 flex justify-between items-center">
                     <span>Select WA Devices for Sending:</span>
                     <SmartphoneNfc size={18} className="text-indigo-600"/>
                 </label>
                 <div className="space-y-2.5 max-h-32 overflow-y-auto bg-white p-3.5 rounded-lg border border-indigo-100">
                    <label className="flex items-center gap-3 cursor-pointer text-sm font-bold text-slate-700 hover:bg-slate-50 p-1.5 rounded transition-colors">
                       <input type="checkbox" checked={selectedDevices.includes('All')} onChange={(e) => {
                           if(e.target.checked) setSelectedDevices(['All']);
                           else setSelectedDevices([]);
                       }} className="w-4 h-4 accent-indigo-600" /> 
                       🌐 All Connected Devices (Auto-Rotate)
                    </label>
                    {activeDevices.map(d => (
                        <label key={d.id} className="flex items-center gap-3 cursor-pointer text-sm font-bold text-slate-700 hover:bg-slate-50 p-1.5 rounded transition-colors border-t border-slate-100">
                           <input type="checkbox" checked={selectedDevices.includes(d.id)} onChange={(e) => {
                               let newSel = selectedDevices.filter(id => id !== 'All');
                               if(e.target.checked) newSel.push(d.id);
                               else newSel = newSel.filter(id => id !== d.id);
                               if(newSel.length === 0) newSel = ['All'];
                               setSelectedDevices(newSel);
                           }} className="w-4 h-4 accent-indigo-600" /> 
                           📱 {d.id}
                        </label>
                    ))}
                 </div>
                 {activeDevices.length === 0 && <p className="text-red-500 text-[10px] mt-2 font-bold">* No devices currently connected. Please link a device first.</p>}
              </div>

              <div className="bg-white border rounded-xl p-4 mb-5 shadow-sm">
                 <label className="block text-sm font-black text-slate-700 mb-3 flex justify-between">
                     <span>API Send Target Percentage:</span>
                     <span className="text-blue-600 bg-blue-50 px-2 py-0.5 rounded border border-blue-100">{smartFilterData.sendPercentage}%</span>
                 </label>
                 <input type="range" min="1" max="100" value={smartFilterData.sendPercentage} onChange={(e) => setSmartFilterData({...smartFilterData, sendPercentage: parseInt(e.target.value)})} className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-600"/>
                 <p className="text-[10px] font-bold text-slate-500 mt-2">* Note: ALL manual numbers are force-included regardless of percentage.</p>
              </div>

              <div className="bg-white border rounded-xl p-4 mb-4 flex justify-between items-center shadow-sm">
                 <div>
                   <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Total Validation</p>
                   <p className="text-2xl font-black text-slate-800">{smartFilterData.allNums.length}</p>
                 </div>
                 <div className="text-right">
                   <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Actual API Targets</p>
                   <p className="text-2xl font-black text-blue-600">{smartFilterData.numbersText.split('\n').filter(n=>n.trim()).length}</p>
                 </div>
              </div>
              
              <div className="mb-4">
                <label className="block text-xs font-bold text-slate-700 mb-2">Final Send List (Extracted Top/Mid/Bottom + Manuals)</label>
                <textarea rows="6" value={smartFilterData.numbersText} onChange={e => setSmartFilterData({...smartFilterData, numbersText: e.target.value})} className="w-full border border-slate-300 rounded-xl p-3 text-sm font-mono outline-none focus:ring-2 focus:ring-blue-500 bg-white shadow-inner"></textarea>
                <p className="text-[10px] font-bold text-slate-500 mt-1">You can manually edit or add numbers to this list before sending.</p>
              </div>
            </div>

            <div className="p-4 bg-white border-t flex justify-end shrink-0 gap-3">
              <button onClick={() => setSmartFilterData(null)} className="px-5 py-2.5 rounded-xl font-bold text-slate-600 bg-slate-100 hover:bg-slate-200">Cancel</button>
              <button onClick={executeSmartSend} disabled={isActionLoading || activeDevices.length === 0} className={`px-6 py-2.5 rounded-xl font-black text-white flex items-center gap-2 ${isActionLoading || activeDevices.length === 0 ? 'bg-slate-400 cursor-not-allowed' : 'bg-emerald-600 hover:bg-emerald-700 shadow-lg'}`}>
                {isActionLoading ? <Loader2 className="animate-spin" size={18}/> : <Megaphone size={18}/>} Start Sending Live
              </button>
            </div>
          </div>
        </div>
      )}

      {mergeConfig.isOpen && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto overflow-x-hidden border border-slate-300">
            <div className="bg-slate-900 px-4 sm:px-6 py-4 sm:py-5 flex justify-between items-center">
              <h3 className="text-white font-bold text-base sm:text-lg flex items-center gap-2"><ArrowRightLeft size={18} className="text-emerald-400"/> Final Master Merge</h3>
              <button onClick={() => setMergeConfig({...mergeConfig, isOpen: false})} disabled={isActionLoading} className="text-slate-400 hover:text-white"><X size={20}/></button>
            </div>
            <div className="p-5 sm:p-6 space-y-6">
               
               <div className="bg-emerald-50 border border-emerald-100 p-4 rounded-xl">
                 <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-3 flex justify-between">
                     <span>Set Status for Remaining {100 - mergeConfig.remainingSentPct}% Numbers:</span>
                     <span className="text-emerald-600 font-black">{mergeConfig.remainingSentPct}% Sent</span>
                 </label>
                 <input type="range" min="0" max="100" value={mergeConfig.remainingSentPct} onChange={(e) => setMergeConfig({...mergeConfig, remainingSentPct: parseInt(e.target.value)})} className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-emerald-600"/>
                 <p className="text-[10px] text-slate-500 mt-2">This percentage applies ONLY to the numbers that are NOT pasted below.</p>
               </div>
               
               <div>
                 <div className="flex justify-between items-center mb-2">
                    <label className="text-xs sm:text-sm font-bold text-slate-700">Paste API / Manual Report Here</label>
                    <span className="text-[9px] text-slate-400">Format: Number, Status</span>
                 </div>
                 <textarea rows="6" value={mergeConfig.pastedData} onChange={e => setMergeConfig({...mergeConfig, pastedData: e.target.value})} placeholder="9999999999, Failed&#10;8888888888, Sent" className="w-full border border-slate-300 rounded-xl p-3 sm:p-4 text-xs sm:text-sm font-mono focus:ring-2 focus:ring-emerald-500 outline-none"></textarea>
               </div>

               <button onClick={executeFinalMerge} disabled={isActionLoading} className={`w-full ${isActionLoading ? 'bg-slate-400' : 'bg-slate-800 hover:bg-slate-900'} text-white py-3.5 rounded-xl font-black text-sm sm:text-base flex items-center justify-center gap-2 shadow-lg`}>
                  {isActionLoading ? <><Loader2 size={16} className="animate-spin" /> Merging & Generating...</> : 'OK & Merge Final Report'}
               </button>
            </div>
          </div>
        </div>
      )}

      <div className="p-4 sm:p-6 border-b border-slate-200"><h2 className="text-lg sm:text-xl font-black text-slate-800">WhatsApp Campaign Reports</h2></div>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse min-w-[700px]">
          <thead>
            <tr className="bg-slate-100 border-b text-slate-500 text-[10px] sm:text-xs uppercase font-bold">
              <th className="p-4 sm:p-5 w-12 sm:w-16"></th><th className="p-4 sm:p-5">Type</th><th className="p-4 sm:p-5">Campaign Name</th><th className="p-4 sm:p-5">Volume Metrics</th><th className="p-4 sm:p-5 text-center">Status / Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-xs sm:text-sm">
            {campaigns.map((camp) => {
              const campMedia = mediaCache[camp.id];
              const isLoading = loadingMedia.has(camp.id);
              
              const manCount = camp.manualCount !== undefined ? camp.manualCount : fastCount(camp.manualNumbers);
              const valCount = camp.validCount !== undefined ? camp.validCount : fastCount(camp.validNumbers);
              const invalCount = camp.invalidCount !== undefined ? camp.invalidCount : fastCount(camp.invalidNumbers);

              return (
              <React.Fragment key={camp.id}>
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 sm:p-5 text-center">
                    <button onClick={() => toggleRow(camp.id)} className="text-slate-400 hover:text-blue-600 bg-white p-1 rounded border shadow-sm" disabled={camp.status === 'Uploading...'}>
                        {expandedRows.has(camp.id) ? <Minus size={16} /> : <Plus size={16} />}
                    </button>
                  </td>
                  <td className="p-4 sm:p-5"><span className="text-[9px] sm:text-[10px] font-black uppercase bg-slate-800 px-2 py-1 rounded-md text-white">{camp.type === 'w-campaign' ? 'W-Camp' : 'Btn-Camp'}</span></td>
                  <td className="p-4 sm:p-5 font-bold text-slate-800">{camp.name} <div className="text-[10px] sm:text-xs text-slate-400 font-medium">{camp.date} <br className="sm:hidden"/>(User: {camp.userName})</div></td>
                  <td className="p-4 sm:p-5">
                    <div className="flex flex-wrap gap-1.5 sm:gap-2 max-w-[200px] sm:max-w-[280px]">
                      <button onClick={() => handleListDownload(camp, 'total')} className="flex-1 min-w-[100px] sm:min-w-[120px] bg-blue-50 border border-blue-200 text-blue-700 hover:bg-blue-100 px-2 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold flex items-center justify-center gap-1 shadow-sm">
                        <Download size={12}/> Total: {camp.numberCount}
                      </button>
                      {isAdmin && manCount > 0 && (
                        <button onClick={() => handleListDownload(camp, 'manual')} className="flex-1 min-w-[100px] sm:min-w-[120px] bg-amber-50 border border-amber-200 text-amber-700 hover:bg-amber-100 px-2 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold flex items-center justify-center gap-1 shadow-sm">
                          <Download size={12}/> Manual: {manCount}
                        </button>
                      )}
                      {isAdmin && valCount > 0 && (
                        <button onClick={() => handleListDownload(camp, 'valid')} className="flex-1 min-w-[100px] sm:min-w-[120px] bg-emerald-50 border border-emerald-200 text-emerald-700 hover:bg-emerald-100 px-2 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold flex items-center justify-center gap-1 shadow-sm">
                          <Download size={12}/> WA Valid: {valCount}
                        </button>
                      )}
                      {isAdmin && invalCount > 0 && (
                        <button onClick={() => handleListDownload(camp, 'invalid')} className="flex-1 min-w-[100px] sm:min-w-[120px] bg-red-50 border border-red-200 text-red-700 hover:bg-red-100 px-2 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold flex items-center justify-center gap-1 shadow-sm">
                          <Download size={12}/> Non-WA: {invalCount}
                        </button>
                      )}
                    </div>
                  </td>
                  <td className="p-4 sm:p-5 text-center align-middle">
                    {camp.status === 'Pending' && isAdmin && !camp.isVirtual ? (
                      <div className="flex flex-col sm:flex-row gap-2 justify-center items-center">
                        <button disabled={isActionLoading} onClick={() => handleAdminAction(camp.id, 'Process')} className={`${isActionLoading ? 'bg-slate-400' : 'bg-indigo-600 hover:bg-indigo-700'} text-white text-[10px] sm:text-xs uppercase tracking-wide px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-bold w-full sm:w-auto`}>Process</button>
                        <button disabled={isActionLoading} onClick={() => handleAdminAction(camp.id, 'Reject')} className={`${isActionLoading ? 'bg-slate-400' : 'bg-red-600 hover:bg-red-700'} text-white text-[10px] sm:text-xs uppercase tracking-wide px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-bold w-full sm:w-auto`}>Reject</button>
                      </div>
                    ) : camp.status === 'Sending Live...' && isAdmin ? (
                      <div className="flex flex-col items-center gap-1 w-full max-w-[180px] mx-auto bg-blue-50 p-2 rounded-lg border border-blue-200 relative group">
                         <div className="absolute -top-3 -right-2 flex gap-1">
                             <button onClick={() => handlePauseCampaign(camp.id)} className="bg-amber-500 text-white rounded-full p-1.5 shadow-md hover:bg-amber-600 hover:scale-110 transition-transform" title="Pause Campaign"><Pause size={14} strokeWidth={3}/></button>
                             <button onClick={() => handleStopCampaign(camp.id)} className="bg-red-600 text-white rounded-full p-1.5 shadow-md hover:bg-red-700 hover:scale-110 transition-transform" title="Stop & Generate Report"><X size={14} strokeWidth={3}/></button>
                         </div>
                         <div className="text-[10px] sm:text-xs font-black text-blue-700 uppercase flex items-center gap-1"><Loader2 size={12} className="animate-spin"/> Sending Live</div>
                         <div className="w-full bg-slate-200 rounded-full h-2.5 mt-1 overflow-hidden">
                           <div className="bg-blue-600 h-2.5 rounded-full transition-all" style={{width: `${Math.min((((camp.liveSent||0) + (camp.liveFailed||0)) / (camp.apiTargetCount||1)) * 100, 100)}%`}}></div>
                         </div>
                         <div className="text-[9px] font-bold text-slate-500 mt-1 flex justify-between w-full"><span>S: {camp.liveSent||0}</span> <span>F: {camp.liveFailed||0}</span> <span>T: {camp.apiTargetCount||0}</span></div>
                      </div>
                    ) : camp.status === 'Paused Manually' && isAdmin ? (
                      <div className="flex flex-col items-center gap-1 w-full max-w-[180px] mx-auto bg-amber-50 p-2 rounded-lg border border-amber-200 relative group">
                         <div className="absolute -top-3 -right-2 flex gap-1">
                             <button onClick={() => handleResumeCampaign(camp.id)} className="bg-emerald-500 text-white rounded-full p-1.5 shadow-md hover:bg-emerald-600 hover:scale-110 transition-transform" title="Resume Campaign"><Play size={14} strokeWidth={3}/></button>
                             <button onClick={() => handleStopCampaign(camp.id)} className="bg-red-600 text-white rounded-full p-1.5 shadow-md hover:bg-red-700 hover:scale-110 transition-transform" title="Stop & Generate Report"><X size={14} strokeWidth={3}/></button>
                         </div>
                         <div className="text-[10px] sm:text-xs font-black text-amber-600 uppercase flex items-center gap-1"><Pause size={12} strokeWidth={3}/> Paused</div>
                         <div className="w-full bg-slate-200 rounded-full h-2.5 mt-1 overflow-hidden">
                           <div className="bg-amber-500 h-2.5 rounded-full transition-all" style={{width: `${Math.min((((camp.liveSent||0) + (camp.liveFailed||0)) / (camp.apiTargetCount||1)) * 100, 100)}%`}}></div>
                         </div>
                         <div className="text-[9px] font-bold text-slate-500 mt-1 flex justify-between w-full"><span>S: {camp.liveSent||0}</span> <span>F: {camp.liveFailed||0}</span> <span>T: {camp.apiTargetCount||0}</span></div>
                      </div>
                    ) : camp.status === 'Paused: No WA Device' && isAdmin ? (
                      <div className="flex flex-col items-center gap-2 w-full max-w-[150px] mx-auto relative">
                         <button onClick={() => handleStopCampaign(camp.id)} className="absolute -top-2 -right-4 bg-red-600 text-white rounded-full p-1.5 shadow-md hover:bg-red-700 z-10" title="Stop Campaign Manually"><X size={14}/></button>
                         <span className="text-[10px] font-black text-red-600 uppercase bg-red-100 px-2 py-1 rounded animate-pulse">Device Offline</span>
                         <button onClick={() => navigate('WADevices')} className="bg-slate-800 text-white text-[9px] uppercase px-3 py-1.5 rounded font-bold w-full">Fix Connection</button>
                      </div>
                    ) : camp.status === 'Report Processing' && isAdmin ? (
                      <div className="flex flex-col gap-2 w-full max-w-[150px] mx-auto">
                         <button disabled={isActionLoading} onClick={() => handleListDownload(camp, 'apiReport')} className="bg-emerald-100 border border-emerald-300 text-emerald-800 hover:bg-emerald-200 text-[10px] sm:text-xs uppercase px-3 py-1.5 rounded-lg font-bold flex items-center justify-center gap-1.5"><Download size={12}/> API Report</button>
                         <button disabled={isActionLoading} onClick={() => setMergeConfig({ isOpen: true, camp: camp, remainingSentPct: 100, pastedData: '' })} className="bg-amber-500 hover:bg-amber-600 text-white text-[10px] sm:text-xs uppercase px-3 py-1.5 rounded-lg font-bold flex items-center justify-center gap-1.5"><ArrowRightLeft size={12}/> Manual Merge</button>
                      </div>
                    ) : camp.status === 'Complete' ? (
                       <button onClick={() => handleDownload(camp.id, camp.name)} className="bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] sm:text-xs uppercase px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-bold flex items-center justify-center gap-1 sm:gap-1.5 mx-auto w-full sm:w-auto"><Download size={12} className="sm:w-[14px] sm:h-[14px]"/> Download Final</button>
                    ) : (
                      <span className={`px-2 sm:px-4 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold border ${camp.status === 'Uploading...' ? 'bg-amber-100 text-amber-800 animate-pulse' : (camp.status === 'Failed' || camp.status.includes('Fail') ? 'bg-red-50 text-red-700' : (['Pending'].includes(camp.status) ? 'bg-amber-50 text-amber-700' : 'bg-indigo-50 text-indigo-700 border-indigo-200'))}`}>
                          {camp.status === 'Uploading...' ? <span className="flex items-center gap-1"><Loader2 size={12} className="animate-spin" /> Uploading...</span> : (!isAdmin && ['Process', 'Sending Live...', 'Paused Manually', 'Paused: No WA Device', 'Report Processing'].includes(camp.status) ? 'Process' : camp.status)}
                      </span>
                    )}
                  </td>
                </tr>
                {expandedRows.has(camp.id) && (
                  <tr className="bg-slate-50/80 shadow-inner">
                    <td colSpan="5" className="p-4 sm:p-8 border-b border-slate-200">
                      <div className="bg-white border border-slate-200 rounded-2xl p-4 sm:p-6 shadow-sm">
                         <div className="flex justify-between items-center mb-4 sm:mb-6 border-b border-slate-100 pb-2 sm:pb-3">
                           <h4 className="font-bold text-slate-800 text-sm sm:text-lg">Campaign Artifacts & Preview (ID: {camp.id})</h4>
                         </div>
                         
                         {isLoading ? (
                            <div className="flex justify-center items-center py-10 text-blue-600"><Loader2 className="animate-spin" size={32}/></div>
                         ) : (
                         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-10">
                           <div className="space-y-4 sm:space-y-5">
                             <h5 className="text-[10px] sm:text-xs font-black text-slate-400 uppercase tracking-widest">Attached Media</h5>
                             {campMedia?.images?.length > 0 && (
                               <div className="grid grid-cols-2 gap-3 sm:gap-4">
                                 {campMedia.images.map((img, i) => (
                                   <div key={i} className="border border-slate-200 p-1.5 sm:p-2 rounded-xl relative group bg-slate-50">
                                     <img src={img.url} alt="Campaign Media" className="w-full h-20 sm:h-28 object-cover rounded-lg bg-white border border-slate-200" />
                                     <div className="mt-1.5 sm:mt-2 text-[10px] sm:text-xs font-bold truncate text-slate-600 px-1">{img.name}</div>
                                     <a href={img.url} download={img.name} className="absolute inset-0 bg-slate-900/70 flex items-center justify-center opacity-0 lg:group-hover:opacity-100 transition-opacity rounded-xl backdrop-blur-sm">
                                       <button className="bg-white text-slate-900 px-3 sm:px-4 py-1 sm:py-1.5 rounded-lg text-[10px] sm:text-xs font-bold flex items-center gap-1 sm:gap-1.5 shadow-lg"><Download size={12}/> Save</button>
                                     </a>
                                     <a href={img.url} download={img.name} className="lg:hidden absolute bottom-8 right-2 bg-white text-blue-600 p-1.5 rounded-md shadow-md border border-slate-200"><Download size={14}/></a>
                                   </div>
                                 ))}
                               </div>
                             )}
                             {campMedia?.video && (
                               <div className="border border-slate-200 p-1.5 sm:p-2 rounded-xl relative group bg-slate-50">
                                  <video src={campMedia.video.url} controls className="w-full h-28 sm:h-36 bg-black rounded-lg" />
                                  <div className="mt-2 sm:mt-3 text-[10px] sm:text-xs font-bold truncate text-slate-600 flex items-center justify-between px-1">
                                    <span className="truncate pr-2">{campMedia.video.name}</span>
                                    <a href={campMedia.video.url} download={campMedia.video.name} className="text-blue-600 hover:bg-blue-50 p-1 sm:p-1.5 rounded-lg shrink-0"><Download size={16}/></a>
                                  </div>
                               </div>
                             )}
                             {campMedia?.pdf && (
                               <div className="border border-slate-200 p-3 sm:p-4 rounded-xl flex items-center justify-between bg-red-50">
                                  <div className="flex items-center gap-2 sm:gap-3 overflow-hidden pr-2"><FileText className="text-red-500 shrink-0" size={24}/><span className="text-xs sm:text-sm font-bold text-slate-800 truncate">{campMedia.pdf.name}</span></div>
                                  <a href={campMedia.pdf.url} download={campMedia.pdf.name} className="bg-white text-red-600 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg shadow-sm font-bold flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-xs border border-red-200 shrink-0"><Download size={14}/> Save PDF</a>
                               </div>
                             )}
                             {campMedia?.btnMedia && (
                               <div className="border border-slate-200 p-1.5 sm:p-2 rounded-xl relative group bg-slate-50">
                                  <div className="w-full h-28 sm:h-36 bg-slate-200 rounded-lg flex items-center justify-center overflow-hidden">
                                    <img src={campMedia.btnMedia.url} className="w-full h-full object-cover" onError={(e) => { e.target.style.display='none' }} alt="media preview" />
                                    <FileBarChart2 size={36} className="text-slate-400 absolute -z-10"/> 
                                  </div>
                                  <div className="mt-2 sm:mt-3 text-[10px] sm:text-xs font-bold truncate text-slate-600 flex items-center justify-between px-1">
                                    <span className="truncate pr-2">{campMedia.btnMedia.name}</span>
                                    <a href={campMedia.btnMedia.url} download={campMedia.btnMedia.name} className="text-blue-600 hover:bg-blue-50 p-1 sm:p-1.5 rounded-lg shrink-0"><Download size={16}/></a>
                                  </div>
                               </div>
                             )}
                             {!campMedia && <p className="text-xs sm:text-sm text-slate-400 italic font-medium bg-slate-50 p-3 sm:p-4 rounded-xl">No media files attached to this campaign.</p>}
                           </div>

                           <div>
                             <h5 className="text-[10px] sm:text-xs font-black text-slate-400 uppercase tracking-widest mb-3 sm:mb-4">Text & Button Config</h5>
                             <div className="bg-[#efe7dd] p-3 sm:p-5 rounded-xl sm:rounded-2xl relative shadow-inner border border-slate-200">
                               <div className="absolute inset-0 opacity-10 pointer-events-none" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")'}}></div>
                               <div className="bg-white p-3 sm:p-4 rounded-xl sm:rounded-2xl rounded-tl-none shadow-sm text-xs sm:text-sm text-[#111B21] whitespace-pre-wrap font-sans inline-block min-w-full relative z-10 border border-slate-100 break-words">
                                 {camp.message}
                                 
                                 {campMedia?.buttons && (campMedia.buttons.btn1?.value || campMedia.buttons.btn2?.value || campMedia.buttons.btn3?.name) && (
                                   <div className="mt-4 pt-3 border-t border-slate-200/60">
                                     <div className="font-bold text-slate-800 mb-2 tracking-[0.2em] text-[14px]">_ _ _ _ _ _ _ _</div>
                                     {campMedia.buttons.btn1?.value && (
                                       <div className="mb-2">
                                         📞 <b>{campMedia.buttons.btn1.name || 'Call Now'}</b><br/>
                                         <span className="text-blue-600">👉 <u>{campMedia.buttons.btn1.value}</u></span>
                                       </div>
                                     )}
                                     {campMedia.buttons.btn2?.value && (
                                       <div className="mb-2">
                                         🌐 <b>{campMedia.buttons.btn2.name || 'Visit Now'}</b><br/>
                                         <span className="text-blue-600">👉 <u>{campMedia.buttons.btn2.value}</u></span>
                                       </div>
                                     )}
                                     {campMedia.buttons.btn3?.name && (
                                       <div>
                                         ✨ <b>{campMedia.buttons.btn3.name}</b><br/>
                                         <span className="text-blue-600">👉 <u>{campMedia.buttons.btn3.value}</u></span>
                                       </div>
                                     )}
                                   </div>
                                 )}
                                 
                               </div>
                             </div>
                           </div>
                         </div>
                         )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ------------------------------------------
// 4. TEMPLATES VIEW
// ------------------------------------------
function TemplatesView({ templates, setTemplates }) {
  const [newTemplate, setNewTemplate] = useState({name: '', text: ''});
  const saveTemplate = (e) => { 
      e.preventDefault(); 
      if(newTemplate.name && newTemplate.text) { 
          setTemplates([...templates, {id: Date.now(), ...newTemplate}]); 
          setNewTemplate({name: '', text: ''}); 
      } 
  };

  return (
    <div className="bg-white shadow-sm rounded-2xl sm:rounded-3xl border border-slate-200 p-5 sm:p-8 max-w-4xl mx-auto">
      <h2 className="text-xl sm:text-2xl font-black text-slate-800 flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8"><BookTemplate className="text-blue-600" size={28}/> Message Templates</h2>
      <form onSubmit={saveTemplate} className="space-y-4 sm:space-y-6 mb-8 sm:mb-10 bg-slate-50 p-5 sm:p-8 rounded-xl sm:rounded-2xl border border-slate-200 shadow-inner">
        <h3 className="text-base sm:text-lg font-bold text-slate-700 border-b border-slate-200 pb-2 sm:pb-3">Create New Template</h3>
        <input type="text" placeholder="Enter Template Name" required value={newTemplate.name} onChange={e=>setNewTemplate({...newTemplate, name:e.target.value})} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-lg sm:rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500 font-bold"/>
        
        <label className="block text-sm font-bold text-slate-700 mb-1 flex justify-between">
           <span>Message Content</span>
           <span className={newTemplate.text.length >= 1000 ? 'text-red-600' : 'text-slate-500'}>({newTemplate.text.length}/1000)</span>
        </label>
        <textarea 
            rows="5" 
            required 
            placeholder="Type your message content here... (Max 1000 char)" 
            value={newTemplate.text} 
            onChange={e => {
                let val = e.target.value;
                if(val.length > 1000) {
                    alert('❌ Maximum 1000 characters allowed. Extra text has been removed.');
                    val = val.substring(0, 1000);
                }
                setNewTemplate({...newTemplate, text:val});
            }} 
            className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-slate-300 rounded-lg sm:rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500"
        ></textarea>

        <div className="flex justify-end pt-1 sm:pt-2">
          <button type="submit" className="w-full sm:w-auto bg-slate-800 text-white px-6 sm:px-8 py-3 rounded-lg sm:rounded-xl text-sm font-bold flex items-center justify-center gap-2 hover:bg-slate-900 shadow-md"><Save size={16}/> Save Template</button>
        </div>
      </form>
      <div className="space-y-3 sm:space-y-4">
        <h3 className="text-base sm:text-lg font-bold text-slate-700">Saved Templates</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          {templates.map(t => (
            <div key={t.id} className="p-4 sm:p-5 border border-slate-200 rounded-xl sm:rounded-2xl hover:bg-blue-50 transition-colors shadow-sm bg-white">
              <div className="font-bold text-sm sm:text-base text-slate-800 flex justify-between mb-2 sm:mb-3">{t.name}<button onClick={() => setTemplates(templates.filter(x => x.id !== t.id))} className="text-red-500 hover:bg-red-100 p-1.5 rounded-md sm:rounded-lg"><X size={14}/></button></div>
              <div className="text-xs sm:text-sm text-slate-600 whitespace-pre-wrap">{t.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------
// 5. CONTACTS VIEW
// ------------------------------------------
function ContactsView({ activeUser, contacts, setContacts }) {
  const [newContact, setNewContact] = useState({name: '', numbers: ''});
  const pastedContactSet = useRef(new Set());
  const permanentlyManualContactSet = useRef(new Set());

  const handlePaste = (e) => {
    const data = e.clipboardData.getData('Text');
    const pastedList = data.split(/\r?\n/).map(n => n.trim().replace(/\D/g, '')).filter(n => n.length === 10 || (n.length === 12 && n.startsWith('91')));
    
    if (pastedList.length <= 5) {
       pastedList.forEach(n => permanentlyManualContactSet.current.add(n));
    } else {
       pastedList.forEach(n => pastedContactSet.current.add(n));
    }
  };

  const handleContactBlur = (e) => {
    const rawList = e.target.value.split(/[\n,]+/).map(n => n.trim().replace(/\D/g, '')).filter(Boolean);
    rawList.forEach(num => {
      let cleaned = num.length === 12 && num.startsWith('91') ? num.substring(2) : num;
      if (cleaned.length === 10) {
        if (!pastedContactSet.current.has(cleaned)) {
          permanentlyManualContactSet.current.add(cleaned);
        }
      }
    });
  };

  const saveContact = (e) => { 
    e.preventDefault(); 
    if(newContact.name && newContact.numbers) { 
      const allNums = newContact.numbers.split(/\r?\n/).map(n=>n.trim().replace(/\D/g, '')).filter(Boolean);
      const cleanAllNums = allNums.map(n => (n.length === 12 && n.startsWith('91')) ? n.substring(2) : n);
      
      const manualNums = cleanAllNums.filter(n => permanentlyManualContactSet.current.has(n));

      setContacts([...contacts, {
        id: Date.now(), 
        name: newContact.name, 
        numbers: newContact.numbers,
        manualNumbers: manualNums 
      }]); 
      
      setNewContact({name: '', numbers: ''}); 
      pastedContactSet.current.clear();
      permanentlyManualContactSet.current.clear();
    } 
  };

  return (
    <div className="bg-white shadow-sm rounded-2xl sm:rounded-3xl border border-slate-200 p-5 sm:p-8 max-w-4xl mx-auto">
      <h2 className="text-xl sm:text-2xl font-black text-slate-800 flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8"><Users className="text-emerald-500" size={28}/> Contact Lists</h2>
      <form onSubmit={saveContact} className="space-y-4 sm:space-y-6 mb-8 sm:mb-10 bg-slate-50 p-5 sm:p-8 rounded-xl sm:rounded-2xl border border-slate-200 shadow-inner">
         <h3 className="text-base sm:text-lg font-bold text-slate-700 border-b border-slate-200 pb-2 sm:pb-3">Create New Contact List</h3>
         <input type="text" placeholder="Enter List Name (e.g. VIP Customers)" required value={newContact.name} onChange={e=>setNewContact({...newContact, name:e.target.value})} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-lg sm:rounded-xl text-sm outline-none focus:ring-2 focus:ring-emerald-500 font-bold"/>
         <textarea rows="6" required placeholder="Paste mobile numbers here (one per line)..." value={newContact.numbers} onChange={e=>setNewContact({...newContact, numbers:e.target.value})} onBlur={handleContactBlur} onPaste={handlePaste} className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-slate-300 rounded-lg sm:rounded-xl text-sm font-mono outline-none focus:ring-2 focus:ring-emerald-500"></textarea>
         <div className="flex justify-end pt-1 sm:pt-2">
           <button type="submit" className="w-full sm:w-auto bg-emerald-600 text-white px-6 sm:px-8 py-3 rounded-lg sm:rounded-xl text-sm font-bold flex items-center justify-center gap-2 hover:bg-emerald-700 shadow-md"><Save size={16}/> Save Contact List</button>
         </div>
      </form>
      <div className="space-y-3 sm:space-y-4">
        <h3 className="text-base sm:text-lg font-bold text-slate-700">Saved Contact Lists</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          {contacts.map(c => (
            <div key={c.id} className="p-4 sm:p-5 border border-slate-200 rounded-xl sm:rounded-2xl flex justify-between items-center hover:bg-emerald-50 transition-colors shadow-sm bg-white">
              <div>
                 <div className="font-bold text-sm sm:text-lg text-slate-800">{c.name}</div>
                 <div className="flex flex-wrap gap-1.5 sm:gap-2 mt-1 sm:mt-1.5">
                    <span className="text-[10px] sm:text-xs text-emerald-700 font-black bg-emerald-100 px-2 sm:px-2.5 py-0.5 rounded-md">{c.numbers.split('\n').filter(n=>n.trim()).length} Contacts</span>
                    
                    {activeUser?.role === 'Admin' && c.manualNumbers && c.manualNumbers.length > 0 && <span className="text-[10px] sm:text-xs text-red-700 font-bold bg-red-100 px-2 sm:px-2.5 py-0.5 rounded-md">{c.manualNumbers.length} Manual</span>}
                 </div>
              </div>
              <button onClick={() => setContacts(contacts.filter(x => x.id !== c.id))} className="text-red-500 hover:bg-red-100 p-1.5 sm:p-2 rounded-md sm:rounded-lg"><X size={18}/></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ------------------------------------------
// 6. MANAGE USER VIEW 
// ------------------------------------------
function ManageUserView({ users, fetchLiveData, setImpersonatedUser, activeUser }) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({ name: '', username: '', mobile: '', email: '', address: '', role: 'User', password: '' });
  const [editingUser, setEditingUser] = useState(null);

  const toggleUserStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';
    try {
       const res = await fetch(`${API_BASE}/api/users/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      });
      if (res.ok) await fetchLiveData();
    } catch(err) { console.error(err); }
  };
  
  const deleteUser = async (id) => {
    if(window.confirm("Are you sure you want to delete this user?")) {
      try {
         const res = await fetch(`${API_BASE}/api/users/${id}`, { method: 'DELETE' });
        if (res.ok) { await fetchLiveData(); alert("User deleted successfully."); } 
        else { alert("Server error: Could not delete user."); }
      } catch(err) { alert("Network Error: Failed to delete."); }
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({...newUser, status: 'Active', wBalance: 0, btnBalance: 0, createdBy: activeUser.username})
      });
      if (res.ok) await fetchLiveData();
    } catch (error) { alert("Failed to add user."); }
    setIsAddModalOpen(false);
    setNewUser({ name: '', username: '', mobile: '', email: '', address: '', role: 'User', password: '' });
  };

  const handleEditUser = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/users/${editingUser.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editingUser)
      });
      if(res.ok) { await fetchLiveData(); alert("User updated successfully!"); }
    } catch(err) { alert("Network failed to update user."); }
    setIsEditModalOpen(false);
    setEditingUser(null);
  };

  const openEditModal = (user) => { setEditingUser({ ...user }); setIsEditModalOpen(true); };

  // 🔥 RESELLER USER FILTER APPLIED HERE 🔥
  const visibleUsers = activeUser.role === 'Admin' ? users : users.filter(u => u.role === 'User' && u.createdBy === activeUser.username);

  return (
    <div className="bg-white p-4 sm:p-8 rounded-2xl border border-slate-200 shadow-sm max-w-5xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 border-b border-slate-100 pb-4 gap-4">
        <h2 className="text-xl sm:text-2xl font-black text-slate-800 flex items-center gap-2 sm:gap-3"><Users className="text-blue-600" size={28}/> User Admin</h2>
        <button onClick={() => setIsAddModalOpen(true)} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg text-sm font-bold flex items-center justify-center gap-2 transition-colors"><UserPlus size={16}/> Add User</button>
      </div>

      {isAddModalOpen && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto overflow-x-hidden border border-slate-300">
            <div className="bg-slate-900 px-5 sm:px-6 py-4 flex justify-between items-center sticky top-0 z-10">
              <h3 className="text-white font-bold text-base sm:text-lg">Create New User</h3>
              <button onClick={() => setIsAddModalOpen(false)} className="text-slate-400 hover:text-white"><X size={20}/></button>
            </div>
            <form onSubmit={handleAddUser} className="p-5 sm:p-6 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Name *</label><input required type="text" value={newUser.name} onChange={e=>setNewUser({...newUser, name: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Username *</label><input required type="text" value={newUser.username} onChange={e=>setNewUser({...newUser, username: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Mobile</label><input type="text" value={newUser.mobile} onChange={e=>setNewUser({...newUser, mobile: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Email</label><input type="email" value={newUser.email} onChange={e=>setNewUser({...newUser, email: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div className="sm:col-span-2"><label className="block text-xs font-bold text-slate-700 mb-1">Address</label><input type="text" value={newUser.address} onChange={e=>setNewUser({...newUser, address: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div>
                  <label className="block text-xs font-bold text-slate-700 mb-1">User Type *</label>
                  <select value={newUser.role} onChange={e=>setNewUser({...newUser, role: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500">
                    <option value="User">User</option>
                    {activeUser.role === 'Admin' && <option value="Reseller">Reseller</option>}
                  </select>
                </div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Password *</label><input required type="text" value={newUser.password} onChange={e=>setNewUser({...newUser, password: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
              </div>
              <div className="pt-4 mt-4 border-t flex justify-end"><button type="submit" className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2.5 rounded-lg font-bold shadow-md hover:bg-blue-700">Save User</button></div>
            </form>
          </div>
        </div>
      )}

      {isEditModalOpen && editingUser && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto overflow-x-hidden border border-slate-300">
            <div className="bg-slate-900 px-5 sm:px-6 py-4 flex justify-between items-center sticky top-0 z-10">
              <h3 className="text-white font-bold text-base sm:text-lg">Edit User</h3>
              <button onClick={() => setIsEditModalOpen(false)} className="text-slate-400 hover:text-white"><X size={20}/></button>
            </div>
            <form onSubmit={handleEditUser} className="p-5 sm:p-6 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Name *</label><input required type="text" value={editingUser.name} onChange={e=>setEditingUser({...editingUser, name: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Username *</label><input required type="text" value={editingUser.username} onChange={e=>setEditingUser({...editingUser, username: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Mobile</label><input type="text" value={editingUser.mobile || ''} onChange={e=>setEditingUser({...editingUser, mobile: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Email</label><input type="email" value={editingUser.email || ''} onChange={e=>setEditingUser({...editingUser, email: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div className="sm:col-span-2"><label className="block text-xs font-bold text-slate-700 mb-1">Address</label><input type="text" value={editingUser.address || ''} onChange={e=>setEditingUser({...editingUser, address: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
                <div>
                  <label className="block text-xs font-bold text-slate-700 mb-1">User Type *</label>
                  <select value={editingUser.role} onChange={e=>setEditingUser({...editingUser, role: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500">
                    <option value="User">User</option>
                    {activeUser.role === 'Admin' && <option value="Reseller">Reseller</option>}
                    {activeUser.role === 'Admin' && <option value="Admin">Admin</option>}
                  </select>
                </div>
                <div><label className="block text-xs font-bold text-slate-700 mb-1">Password *</label><input required type="text" value={editingUser.password || ''} onChange={e=>setEditingUser({...editingUser, password: e.target.value})} className="w-full border px-3 py-2 rounded-lg text-sm outline-none focus:border-blue-500" /></div>
              </div>
              <div className="pt-4 mt-4 border-t flex justify-end"><button type="submit" className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2.5 rounded-lg font-bold shadow-md hover:bg-blue-700">Update User</button></div>
            </form>
          </div>
        </div>
      )}

      {visibleUsers.length === 0 ? (
         <div className="text-center p-6 sm:p-10 font-bold text-slate-500">No Users Found.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {visibleUsers.map(u => (
            <div key={u.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 sm:p-5 border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors shadow-sm bg-white gap-4 sm:gap-0">
              <div className="w-full sm:w-auto">
                 <div className="flex items-center gap-2">
                   <p className="font-black text-slate-800 text-base sm:text-lg">{u.username}</p>
                   <span className={`w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full ${u.status === 'Active' ? 'bg-emerald-500' : 'bg-red-500'}`}></span>
                 </div>
                 <p className="text-[10px] sm:text-xs text-slate-500 font-bold mt-1 bg-slate-100 inline-block px-2 py-0.5 rounded">Role: {u.role}</p>
                 <div className="flex flex-wrap gap-2 sm:gap-3 mt-2 sm:mt-3 text-[10px] sm:text-xs font-bold text-slate-600">
                   <span>W-Bal: <span className="text-indigo-600">{u.role === 'Admin' ? 'Unlimited' : u.wBalance}</span></span>
                   <span>Btn-Bal: <span className="text-cyan-600">{u.role === 'Admin' ? 'Unlimited' : u.btnBalance}</span></span>
                 </div>
              </div>
              
              {u.role !== 'Admin' && (
                <div className="flex flex-col gap-2 w-full sm:w-auto">
                  <button onClick={()=>setImpersonatedUser(u)} className="bg-slate-800 text-white px-4 py-2 text-[10px] sm:text-xs font-bold rounded-lg hover:bg-slate-900 shadow-md flex items-center gap-2 justify-center transition-all"><LogIn size={12} className="sm:w-[14px] sm:h-[14px]"/> Login As</button>
                  <div className="flex gap-2">
                    <button onClick={()=>toggleUserStatus(u.id, u.status)} className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 py-1.5 sm:py-2 rounded-lg flex items-center justify-center transition-colors" title="Toggle Status">
                      {u.status === 'Active' ? <ToggleLeft size={14} className="sm:w-4 sm:h-4"/> : <ToggleRight size={14} className="text-emerald-600 sm:w-4 sm:h-4"/>}
                    </button>
                    <button onClick={()=>openEditModal(u)} className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-600 py-1.5 sm:py-2 rounded-lg flex items-center justify-center transition-colors" title="Edit User"><Edit size={14} className="sm:w-4 sm:h-4"/></button>
                    <button onClick={()=>deleteUser(u.id)} className="flex-1 bg-red-50 hover:bg-red-100 text-red-600 py-1.5 sm:py-2 rounded-lg flex items-center justify-center transition-colors" title="Delete User"><Trash2 size={14} className="sm:w-4 sm:h-4"/></button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ------------------------------------------
// 7. CREDIT MANAGEMENT VIEW 
// ------------------------------------------
function CreditManageView({ users, fetchLiveData, activeUser }) {
  const [selectedUserId, setSelectedUserId] = useState('');
  const [txData, setTxData] = useState({ walletType: 'W Credit', actionType: 'Add', amount: '', note: '' });
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  // 🔥 RESELLER USER FILTER APPLIED HERE 🔥
  const visibleUsers = activeUser?.role === 'Admin' ? users.filter(u => u.role !== 'Admin') : users.filter(u => u.role === 'User' && u.createdBy === activeUser?.username);
  
  const targetUser = users.find(u => u.id === Number(selectedUserId));

  const handleTransaction = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');
    const amount = Number(txData.amount);
    
    if (targetUser && amount > 0) {
      const isDeduct = txData.actionType === 'Deduct';
          
      if (isDeduct) {
          if (txData.walletType === 'W Credit' && targetUser.wBalance < amount) {
              setErrorMsg(`User only has ${targetUser.wBalance} W Credits. Cannot deduct ${amount}.`); return;
          }
          if (txData.walletType === 'Button Credit' && targetUser.btnBalance < amount) {
              setErrorMsg(`User only has ${targetUser.btnBalance} Button Credits. Cannot deduct ${amount}.`); return;
          }
      }

      if (activeUser?.role === 'Reseller' && !isDeduct) {
         if (txData.walletType === 'W Credit' && activeUser.wBalance < amount) {
            setErrorMsg(`Insufficient W Credits. You only have ${activeUser.wBalance}.`); return;
         }
         if (txData.walletType === 'Button Credit' && activeUser.btnBalance < amount) {
            setErrorMsg(`Insufficient Button Credits. You only have ${activeUser.btnBalance}.`); return;
         }
      }

      setIsProcessing(true);
      const actualAmount = isDeduct ? -amount : amount;
      const payload = { userId: targetUser.id, wBalance: txData.walletType === 'W Credit' ? actualAmount : 0, btnBalance: txData.walletType === 'Button Credit' ? actualAmount : 0 };

      try {
        if (activeUser?.role === 'Reseller' && !isDeduct) {
            await fetch(`${API_BASE}/api/users/update-credit`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: activeUser.id, wBalance: txData.walletType === 'W Credit' ? -amount : 0, btnBalance: txData.walletType === 'Button Credit' ? -amount : 0 })
            });
        } else if (activeUser?.role === 'Reseller' && isDeduct) {
            await fetch(`${API_BASE}/api/users/update-credit`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: activeUser.id, wBalance: txData.walletType === 'W Credit' ? amount : 0, btnBalance: txData.walletType === 'Button Credit' ? amount : 0 })
            });
        }

        const res = await fetch(`${API_BASE}/api/users/update-credit`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
        });

        if (res.ok) {
          const targetLogData = { userId: targetUser.id, username: targetUser.username, walletType: txData.walletType, type: isDeduct ? 'Deduction' : 'Credit', amount: amount, date: new Date().toLocaleString(), note: txData.note || (isDeduct ? 'Removed by Admin' : 'Credit Received'), campaignName: '-' };
          await fetch(`${API_BASE}/api/credit-logs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(targetLogData) });
          
          if (activeUser?.role === 'Reseller') {
              const resellerLogData = { userId: activeUser.id, username: activeUser.username, walletType: txData.walletType, type: isDeduct ? 'Credit' : 'Deduction', amount: amount, date: new Date().toLocaleString(), note: isDeduct ? `Recovered from @${targetUser.username}` : `Transferred to @${targetUser.username}`, campaignName: '-' };
              await fetch(`${API_BASE}/api/credit-logs`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(resellerLogData) });
          }

          await fetchLiveData(); 
          setSuccessMsg(`Successfully ${isDeduct ? 'removed' : 'added'} ${amount} ${txData.walletType} ${isDeduct ? 'from' : 'to'} ${targetUser.username}'s account.`);
          setTxData({ walletType: 'W Credit', actionType: 'Add', amount: '', note: '' });
        } else { setErrorMsg("Failed to save credit to server database."); }
      } catch (error) { setErrorMsg("Server error. Please check your backend."); } 
      finally { setIsProcessing(false); }
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white shadow-lg rounded-2xl sm:rounded-3xl border border-slate-200 overflow-hidden">
        <div className="p-4 sm:p-6 border-b border-slate-200 bg-slate-50 flex items-center gap-2 sm:gap-3">
          <CreditCard className="text-blue-600" size={28} />
          <h2 className="text-lg sm:text-xl font-black text-slate-800">Manage Credits</h2>
        </div>
        
        <form onSubmit={handleTransaction} className="p-5 sm:p-8">
          {successMsg && <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-emerald-50 text-emerald-700 rounded-xl border border-emerald-200 text-xs sm:text-sm font-bold flex items-center gap-2 shadow-sm"><CheckCircle size={18} className="shrink-0"/> {successMsg}</div>}
          {errorMsg && <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-red-50 text-red-700 rounded-xl border border-red-200 text-xs sm:text-sm font-bold flex items-center gap-2 shadow-sm"><AlertTriangle size={18} className="shrink-0"/> {errorMsg}</div>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8 mb-6 sm:mb-8">
            <div className="col-span-1 md:col-span-2">
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1.5 sm:mb-2">Select Account *</label>
              <select value={selectedUserId} onChange={(e) => setSelectedUserId(e.target.value)} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none shadow-sm text-xs sm:text-sm" required>
                <option value="">-- Select User --</option>
                {visibleUsers.map(u => ( <option key={u.id} value={u.id}>{u.name} (@{u.username}) - {u.role}</option> ))}
              </select>
              
              {targetUser && (
                <div className="mt-3 sm:mt-4 text-[10px] sm:text-sm p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded-xl text-blue-900 flex flex-col sm:flex-row justify-between items-start sm:items-center shadow-inner gap-2 sm:gap-0">
                  <span className="font-bold text-blue-700">Current Balance:</span>
                  <div className="flex gap-2 sm:gap-4 w-full sm:w-auto">
                    <div className="flex-1 sm:flex-none font-black bg-white px-2 sm:px-3 py-1 rounded-lg border border-blue-100 text-center">W: {targetUser.wBalance}</div>
                    <div className="flex-1 sm:flex-none font-black bg-white px-2 sm:px-3 py-1 rounded-lg border border-blue-100 text-center">Btn: {targetUser.btnBalance}</div>
                  </div>
                </div>
              )}
            </div>

            <div>
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1.5 sm:mb-2">Wallet Type *</label>
              <select value={txData.walletType} onChange={(e) => setTxData({...txData, walletType: e.target.value})} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none shadow-sm text-xs sm:text-sm font-medium">
                <option value="W Credit">W-Campaign Credit</option>
                <option value="Button Credit">Button Campaign Credit</option>
              </select>
            </div>

            <div>
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1.5 sm:mb-2">Action Type *</label>
              <select value={txData.actionType} onChange={(e) => setTxData({...txData, actionType: e.target.value})} className={`w-full px-4 sm:px-5 py-2.5 sm:py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none shadow-sm text-xs sm:text-sm font-bold ${txData.actionType === 'Deduct' ? 'border-red-300 text-red-700 bg-red-50' : 'border-emerald-300 text-emerald-700 bg-emerald-50'}`}>
                <option value="Add">Add Credit (+)</option>
                <option value="Deduct">Remove Credit (-)</option>
              </select>
            </div>

            <div>
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1.5 sm:mb-2">Amount *</label>
              <input type="number" min="1" required value={txData.amount} onChange={(e) => setTxData({...txData, amount: e.target.value})} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none shadow-sm text-xs sm:text-sm font-bold" placeholder="0" />
            </div>
            
            <div>
              <label className="block text-xs sm:text-sm font-bold text-slate-700 mb-1.5 sm:mb-2">Transaction Note / Ref *</label>
              <input type="text" required value={txData.note} onChange={(e) => setTxData({...txData, note: e.target.value})} className="w-full px-4 sm:px-5 py-2.5 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none shadow-sm text-xs sm:text-sm" placeholder="e.g. Bank Transfer #12345" />
            </div>
          </div>

          <div className="flex justify-end pt-5 sm:pt-6 border-t border-slate-200">
            <button type="submit" disabled={isProcessing} className={`w-full sm:w-auto ${isProcessing ? 'bg-slate-400' : (txData.actionType === 'Deduct' ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700')} text-white px-6 sm:px-10 py-3 rounded-xl shadow-lg font-black flex items-center justify-center gap-2 transition-all text-sm sm:text-lg`}>
                {txData.actionType === 'Deduct' ? <Minus size={18} className="sm:w-5 sm:h-5"/> : <Plus size={18} className="sm:w-5 sm:h-5"/>} 
                {isProcessing ? 'Processing...' : (txData.actionType === 'Deduct' ? 'Remove Credits' : 'Add Credits')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ------------------------------------------
// 8. CREDIT HISTORY VIEW 
// ------------------------------------------
function CreditHistoryView({ creditLogs, activeUser, isAdmin }) {
  const visibleLogs = isAdmin ? creditLogs : creditLogs.filter(log => log.username === activeUser.username);

  const formatMemo = (note) => {
     if(!note) return 'Send';
     const l = note.toLowerCase();
     if(l.includes('fail') || l.includes('reject')) return 'Failed/Reject';
     if(l.includes('campaign sent') || l.includes('deduct')) return 'Send';
     return note;
  };

  return (
    <div className="bg-white shadow-sm rounded-2xl border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse min-w-[600px]">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] sm:text-xs uppercase tracking-wider font-bold">
              <th className="p-4 sm:p-5">Date & Time</th>
              {isAdmin && <th className="p-4 sm:p-5">User</th>}
              <th className="p-4 sm:p-5">Wallet Class</th>
              <th className="p-4 sm:p-5">Action</th>
              <th className="p-4 sm:p-5">Campaign Ref</th>
              <th className="p-4 sm:p-5">Amount</th>
              <th className="p-4 sm:p-5">Memo</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-xs sm:text-sm">
            {visibleLogs.map((log) => (
              <tr key={log.id} className="hover:bg-slate-50 transition-colors">
                <td className="p-4 sm:p-5 text-slate-500 font-bold text-[10px] sm:text-xs whitespace-nowrap">{log.date}</td>
                {isAdmin && <td className="p-4 sm:p-5 font-black text-slate-900 text-xs sm:text-sm">@{log.username}</td>}
                <td className="p-4 sm:p-5">
                  <span className="bg-slate-100 text-slate-700 px-2 sm:px-3 py-1 sm:py-1.5 rounded-md sm:rounded-lg text-[10px] sm:text-xs font-bold border border-slate-200 shadow-sm whitespace-nowrap">
                    {log.walletType}
                  </span>
                </td>
                <td className="p-4 sm:p-5">
                   <span className={`inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1 sm:py-1.5 rounded-md sm:rounded-lg text-[9px] sm:text-[10px] font-black uppercase tracking-widest shadow-sm whitespace-nowrap
                      ${log.type === 'Credit' || log.type === 'Refund' ? 'bg-emerald-100 text-emerald-800 border border-emerald-200' : 'bg-red-100 text-red-800 border border-red-200'}`}>
                    {log.type === 'Credit' || log.type === 'Refund' ? 'Refund / Credit' : 'Deducted'}
                  </span>
                </td>
                <td className="p-4 sm:p-5 text-slate-800 font-bold max-w-[120px] sm:max-w-[180px] truncate" title={log.campaignName}>{log.campaignName || '-'}</td>
                <td className={`p-4 sm:p-5 font-black text-base sm:text-xl ${log.type === 'Credit' || log.type === 'Refund' ? 'text-emerald-600' : 'text-red-600'}`}>
                  {log.amount}
                </td>
                <td className="p-4 sm:p-5 text-slate-600 font-bold text-[10px] sm:text-xs">
                   <span className="bg-slate-100 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded border border-slate-200">{formatMemo(log.note)}</span>
                </td>
              </tr>
            ))}
            {visibleLogs.length === 0 && (
              <tr><td colSpan={isAdmin ? 7 : 6} className="p-6 sm:p-10 text-center text-slate-400 font-bold text-sm sm:text-lg">No audit records found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}